<template>
  <div v-if="helper.master.labels">
    <spacer :y="5"/>
    <ul>
      <stack-item>
        <contents-box
          :title="`${organizationTypeLabel}基本情報更新`"
          id="confirm">
          <div :class="$style.prev_right"><prev-btn /></div>
          <spacer :y="2" />
          <loader-simple :flag="flag.loader">
            <div v-show="!flag.loader">
              <div :class="$style.wrapper">
                <div
                  v-for="row in organizationTypes"
                  :key="row">
                  <div v-if="school && school.id" :class="$style.row">
                    <div :class="$style.label_wrap">
                      <p :class="$style.label">組織ID：{{ school.id }}</p>
                    </div>
                  </div>
                  <div :class="rowGroupClass(row.name)">
                    <div :class="$style.label_wrap">
                      <p :class="$style.label">{{ row.label }}</p>
                      <p v-if="row.required" :class="$style.required">※必須項目</p>
                    </div>
                    <div
                      :class="$style.detail"
                      v-if="row.type === 'radio'">
                      <ul :class="$style.radio">
                        <li
                          v-for="opt in row.options"
                          :key="opt">
                          <input
                            type="radio"
                            :name="row.name"
                            :id="opt.name"
                            :disabled="true"
                            :value="opt.value"
                            v-model="this[row.name]"
                            @change="changeOrganizationType(row.name)">
                          <label :for="opt.name">{{ opt.label }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div v-for="row in orderedContents" :key="row">
                <div
                  :class="rowGroupClass(row.name)"
                  v-show="isRowVisible(row)">
                  <div :class="$style.label_wrap">
                    <p :class="rowLabelClass(row.name)">
                      {{ row.label }}
                    </p>

                    <p
                      v-if="(row.required && row.name !== 'school_type')
                        || (row.required && row.name === 'school_type' && !is_company)"
                      :class="$style.required">※必須項目</p>
                  </div>
                  <!-- 契約情報ブロック（契約プラン・契約情報）は住所の下へ移動（B2）。描画は住所直後の block を参照 -->

                  <!-- ラジオボタン（学校タイプ） -->
                  <div
                    :class="$style.detail"
                    v-if="row.type === 'radio'
                      && row.name !== 'billing_type'
                      && row.name !== 'course'
                      && row.name === 'school_type'">
                    <ul :class="$style.radio">
                      <li v-for="opt in row.options" :key="opt">
                        <input
                          type="radio"
                          :name="row.name"
                          :id="opt.name"
                          :disabled="flag.isConfirm || this.is_company"
                          :value="opt.value"
                          v-model="this.contents[1].value">
                        <label
                          :for="opt.name"
                          :class="this.is_company
                            ? 'disabled'
                            : ''">{{ opt.label }}</label>
                      </li>
                    </ul>
                  </div>

                  <!-- テキスト -->
                  <div :class="$style.detail" v-if="row.type === 'text'">
                    <div>
                      <input
                        v-if="row.name === 'kana'"
                        :class="$style.text"
                        :name="row.name"
                        :disabled="flag.isConfirm"
                        :placeholder="flag.isConfirm ? '' : (is_company && row.cplaceholder ? row.cplaceholder : row.placeholder)"
                        type="text"
                        v-model.trim="$v.siteKana.$model"
                        v-on:input="onKanaInput(row, 'siteKana', $v.siteKana.$model, $v.siteKana.$invalid)"
                        @compositionend="onKanaCompositionEnd('siteKana', row)"
                        @blur="onKanaCompositionEnd('siteKana', row)">
                      <input
                        v-else
                        :class="$style.text"
                        :name="row.name"
                        :disabled="flag.isConfirm"
                        :placeholder="flag.isConfirm ? '' : (is_company && row.cplaceholder ? row.cplaceholder : row.placeholder)"
                        type="text" v-model="row.value">
                    </div>
                    <p :class="$style.assistant" v-if="!flag.isConfirm">{{ row.assistant }}</p>
                  </div>

                  <div :class="$style.detail" v-if="row.name === 'emailUser'">
                    <div>
                      <input
                        :class="$style.text"
                        :disabled="flag.isConfirm"
                        placeholder="メールアドレス"
                        v-model.trim="$v.mailUser.$model"
                        id="mailUser"
                        type="emailUser"
                        name="mailUser"
                        v-on:input="invalidsCheck('mailUser', $v.mailUser.$invalid)">
                      <p
                        :class="$style.required"
                        v-if="$v.mailUser.$dirty
                          && $v.mailUser.required.$invalid">メールアドレスを入力してください</p>
                      <p
                        :class="$style.required"
                        v-if="$v.mailUser.$dirty
                          && $v.mailUser.email.$invalid">正しいメールアドレスの形式で入力してください</p>
                    </div>
                  </div>
                </div>

                  <!--住所。電話番号行をアンカーにして「電話番号の直下」に描画する
                       （サイト表示名・カナは住所より後ろへ回すため orderedContents 側で並べ替える）。
                       アンカーは組織メールアドレス撤去まで mail 行だった。必須項目である tel へ移したので、
                       任意項目が消えてもアンカーごと住所が落ちることはない。 -->
                  <div :class="$style.row" v-if="row.name === 'tel'">
                    <div :class="$style.label_wrap">
                      <p :class="$style.label">住所</p>
                      <p :class="$style.required">※必須項目</p>
                    </div>
                    <div :class="$style.detail">
                      <spacer :y="2"/>
                      <Address
                        @sendValue="receiveValue"
                        :items="items"
                        :isConfirm="flag.isConfirm"
                        ref="address" />
                    </div>
                  </div>

                  <!-- ブロックA: 契約プラン・パターン種別を学校タイプ直下へ配置（B2 再分割）。school_type 行を
                       アンカーにする（is_company 組織では学校タイプ本体は非表示だが v-for 反復は常に走るため描画される）。 -->
                  <div :class="$style.row" v-if="row.name === 'school_type'">
                    <div :class="$style.label_wrap">
                      <p :class="$style.label">{{ contents[0].label }}</p>
                      <p v-if="contents[0].required" :class="$style.required">※必須項目</p>
                    </div>
                    <div :class="$style.detail">
                      <ul :class="$style.radio">
                        <li v-for="opt in billingPlanOptions" :key="opt">
                          <input
                            type="radio"
                            :name="contents[0].name"
                            :id="opt.name"
                            :disabled="flag.isConfirm"
                            :value="opt.value"
                            v-model="contents[0].value"
                            v-on:change="updateBillingTypeValue">
                          <label :for="opt.name">{{ opt.label }}</label>
                        </li>
                      </ul>
                      <div>
                        <spacer :y="2" />
                        <ul :class="$style.contract">
                          <!-- パターン種別（measuredDatas の radio 行のみ）。v-if+v-for 同居は Vue3 で loop 変数を
                               参照できないため template v-for + li v-if で行フィルタする。 -->
                          <template v-for="row in measuredDatas">
                            <li v-if="row.inputType === 'radio'" :key="row" :class="$style.contract_list">
                              <div v-if="judgeDisplay(row)" :class="$style.label_wrap">
                                <p :class="$style.label">{{ row.label }}</p>
                              </div>
                              <div>
                                <ul v-if="row.cycle && contents[0].value === 1" :class="$style.radio">
                                  <li v-for="opt in row.cycle" :key="opt">
                                    <input
                                      type="radio"
                                      :name="row.label"
                                      :id="opt.label"
                                      :disabled="flag.isConfirm"
                                      :value="opt.value"
                                      v-model="row.value">
                                    <label :for="opt.label">{{ opt.label }}</label>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </template>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ブロックB: テキスト基本回数・契約名・契約年月日（measuredDatas の非 radio 行）を住所直後に残す
                     （B2 再分割）。契約プラン・パターン種別はブロックA（学校タイプ直下）へ分離した。
                     表示順は配列順（契約名→契約年月日→テキスト基本回数）ではなく「テキスト基本回数→契約名→契約年月日」に
                     並べ替える。配列 measuredDatas は不変のまま、template を2パスに分けて表示順のみ入れ替える
                     （サステナブル時は pop() で textDefaultCount が配列から消え、契約名→契約年月日 のみが自然に残る）。 -->
                <div :class="$style.row">
                  <div :class="$style.detail">
                    <div>
                      <ul :class="$style.contract_flat">
                        <!-- パス1: テキスト基本回数（先頭） -->
                        <template v-for="row in measuredDatas">
                        <li v-if="row.inputType !== 'radio' && row.name === 'textDefaultCount'" :key="row"
                          :class="$style.contract_list">
                          <div v-if="judgeDisplay(row)" :class="$style.label_wrap">
                            <p :class="$style.label">{{ row.label }}</p>
                            <p v-if="row.required && row.inputType !== 'radio'" :class="$style.required">※必須項目</p>
                          </div>
                          <div v-if="row.name === 'contractDate'"><!-- 契約年月日 -->
                            <ul :class="$style.select_wrap">
                              <li>
                                <select
                                  :class="$style.select"
                                  name="contractDate"
                                  id="year"
                                  :disabled="flag.isConfirm"
                                  @change="updateContractDate"
                                  v-model="row.values.year">
                                <option :value="0"></option>
                                <option
                                  v-for="n of 20"
                                  :key="n"
                                  :value="optionYear(n)">{{ optionYear(n) }}</option>
                                </select>年
                              </li>
                              <li>
                                <select
                                  :class="$style.select"
                                  name="contractDate"
                                  id="month"
                                  :disabled="flag.isConfirm"
                                  @change="updateContractDate"
                                  v-model="row.values.month">
                                <option :value="0"></option>
                                <option
                                  v-for="n of 12"
                                  :key="n"
                                  :value="n">{{ n }}</option>
                                </select>月
                              </li>
                              <li>
                                <select
                                  :class="$style.select"
                                  name="contractDate"
                                  id="day"
                                  :disabled="flag.isConfirm"
                                  @change="updateContractDate"
                                  v-model="row.values.day">
                                <option :value="0"></option>
                                <option
                                  v-for="n of 31"
                                  :key="n"
                                  :value="n">{{ n }}</option>
                                </select>日
                              </li>
                            </ul>
                          </div>
                          <input v-else
                            :class="$style.text"
                            :type="row.inputType"
                            :disabled="flag.isConfirm"
                            v-model="row.value">
                        </li>
                        </template>
                        <!-- パス2: 契約名 → 契約年月日 -->
                        <template v-for="row in measuredDatas">
                        <li v-if="row.inputType !== 'radio' && row.name !== 'textDefaultCount'" :key="row"
                          :class="$style.contract_list">
                          <div v-if="judgeDisplay(row)" :class="$style.label_wrap">
                            <p :class="$style.label">{{ row.label }}</p>
                            <p v-if="row.required && row.inputType !== 'radio'" :class="$style.required">※必須項目</p>
                          </div>
                          <div v-if="row.name === 'contractDate'"><!-- 契約年月日 -->
                            <ul :class="$style.select_wrap">
                              <li>
                                <select
                                  :class="$style.select"
                                  name="contractDate"
                                  id="year"
                                  :disabled="flag.isConfirm"
                                  @change="updateContractDate"
                                  v-model="row.values.year">
                                <option :value="0"></option>
                                <option
                                  v-for="n of 20"
                                  :key="n"
                                  :value="optionYear(n)">{{ optionYear(n) }}</option>
                                </select>年
                              </li>
                              <li>
                                <select
                                  :class="$style.select"
                                  name="contractDate"
                                  id="month"
                                  :disabled="flag.isConfirm"
                                  @change="updateContractDate"
                                  v-model="row.values.month">
                                <option :value="0"></option>
                                <option
                                  v-for="n of 12"
                                  :key="n"
                                  :value="n">{{ n }}</option>
                                </select>月
                              </li>
                              <li>
                                <select
                                  :class="$style.select"
                                  name="contractDate"
                                  id="day"
                                  :disabled="flag.isConfirm"
                                  @change="updateContractDate"
                                  v-model="row.values.day">
                                <option :value="0"></option>
                                <option
                                  v-for="n of 31"
                                  :key="n"
                                  :value="n">{{ n }}</option>
                                </select>日
                              </li>
                            </ul>
                          </div>
                          <input v-else
                            :class="$style.text"
                            :type="row.inputType"
                            :disabled="flag.isConfirm"
                            v-model="row.value">
                        </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                </div>

                <div :class="$style.row">
                  <div :class="$style.label_wrap">
                    <p :class="$style.label">医師心理士への共有メモ</p>
                  </div>
                  <div :class="$style.detail">
                    <spacer :y="2"/>
                    <textarea
                      :class="$style.textarea"
                      v-model="features"
                      @change="flag.changeSchoolMemo = true"
                      :disabled="flag.isConfirm"
                      placeholder="導入校・導入企業の特色を入力してください。入力テキストは医師心理士サイト上で閲覧可能です。"
                      rows="5"></textarea>
                  </div>
                </div>

                <div :class="$style.row">
                  <div :class="$style.label_wrap">
                    <p :class="$style.label">メモ（事務局のみ閲覧可）</p>
                  </div>
                  <div :class="$style.detail">
                    <spacer :y="2"/>
                    <textarea
                      :class="$style.textarea"
                      v-model="schoolMemo"
                      @change="flag.changeSchoolMemo = true"
                      :disabled="flag.isConfirm"
                      placeholder="備考"
                      rows="5"></textarea>
                  </div>
                </div>

                <!-- 契約担当者（基本情報ブロックの末尾・確認/確定ボタンの直前）。
                     法人名／法人名カナは「管理者と同一」チェックボックスより上・v-if の外に置き、ON/OFF に
                     関わらず常時表示する。v-if の内側だと既定 ON（実運用のほぼ全組織）で入力欄が消え、
                     法人名が FE の必須項目のため保存自体が成立しなくなるため（updater 側には
                     必須ガードを置いていない — 部分更新の呼び出しを壊さないため）。
                     保存先は schools.corporate_name / corporate_kana で、ON で contractPersons 行が
                     削除されても法人名は残る。 -->
                <div :class="$style.row">
                  <div :class="$style.label_wrap">
                    <p :class="$style.label">契約担当者</p>
                  </div>
                  <div :class="$style.detail">
                    <spacer :y="2"/>
                    <div :class="$style.label_wrap">
                      <p :class="$style.sub_label">{{ corporateNameRow.label }}</p>
                      <p v-if="corporateNameRow.required" :class="$style.required">※必須項目</p>
                    </div>
                    <input
                      :class="$style.text"
                      type="text"
                      :name="corporateNameRow.name"
                      :disabled="flag.isConfirm"
                      :placeholder="flag.isConfirm ? '' : corporateNameRow.placeholder"
                      v-model="corporateNameRow.value">
                    <spacer :y="2"/>
                    <div :class="$style.label_wrap">
                      <p :class="$style.sub_label">{{ corporateKanaRow.label }}</p>
                      <p v-if="corporateKanaRow.required" :class="$style.required">※必須項目</p>
                    </div>
                    <input
                      :class="$style.text"
                      type="text"
                      :name="corporateKanaRow.name"
                      :disabled="flag.isConfirm"
                      :placeholder="flag.isConfirm ? '' : corporateKanaRow.placeholder"
                      v-model.trim="$v.kana.$model"
                      v-on:input="onKanaInput(corporateKanaRow, 'kana', $v.kana.$model, $v.kana.$invalid)"
                      @compositionend="onKanaCompositionEnd('kana', corporateKanaRow)"
                      @blur="onKanaCompositionEnd('kana', corporateKanaRow)">
                    <spacer :y="2"/>
                    <label :class="$style.same_as_admin">
                      <input
                        type="checkbox"
                        :disabled="flag.isConfirm"
                        v-model="contractPerson.sameAsAdmin">
                      管理者と同一
                    </label>
                    <div v-if="!contractPerson.sameAsAdmin">
                      <spacer :y="2"/>
                      <div :class="$style.label_wrap">
                        <p :class="$style.sub_label">氏名</p>
                        <p :class="$style.required">※必須項目</p>
                      </div>
                      <input
                        :class="$style.text"
                        type="text"
                        :disabled="flag.isConfirm"
                        placeholder="例：山田 太郎"
                        v-model="contractPerson.name">
                      <spacer :y="2"/>
                      <div :class="$style.label_wrap">
                        <p :class="$style.sub_label">カナ</p>
                        <p :class="$style.required">※必須項目</p>
                      </div>
                      <input
                        :class="$style.text"
                        type="text"
                        :disabled="flag.isConfirm"
                        placeholder="例：ヤマダ タロウ"
                        v-model="contractPerson.kana"
                        @blur="normalizeContractPersonKana">
                      <!-- 契約担当者の部署/職階は組織種類によらず固定 2 列（mixin contractPersonFieldDefs が定義元）。
                           主管理者の表示列制御（schoolAdminFields・種別で列数可変）とは別軸なので参照しない。
                           下の必須判定・alert 語彙も同じ defs を走査するため、入力欄の増減と必須チェックの
                           対象が構造的にズレない（欄が無いのに必須で止まる false-block を防ぐ）。 -->
                      <template v-for="f in contractPersonFieldDefs()" :key="f.name">
                        <spacer :y="2"/>
                        <div :class="$style.label_wrap">
                          <p :class="$style.sub_label">{{ f.label }}</p>
                          <p :class="$style.required">※必須項目</p>
                        </div>
                        <input
                          :class="$style.text"
                          type="text"
                          :disabled="flag.isConfirm"
                          v-model="contractPerson[f.name]">
                      </template>
                      <spacer :y="2"/>
                      <div :class="$style.label_wrap">
                        <p :class="$style.sub_label">電話番号</p>
                        <p :class="$style.required">※必須項目</p>
                      </div>
                      <input
                        :class="$style.text"
                        type="text"
                        :disabled="flag.isConfirm"
                        v-model="contractPerson.tel">
                      <p :class="$style.assistant" v-if="!flag.isConfirm">半角・ハイフンなしで入力してください</p>
                      <spacer :y="2"/>
                      <div :class="$style.label_wrap">
                        <p :class="$style.sub_label">メールアドレス</p>
                        <p :class="$style.required">※必須項目</p>
                      </div>
                      <input
                        :class="$style.text"
                        type="email"
                        :disabled="flag.isConfirm"
                        :placeholder="flag.isConfirm ? '' : 'メールアドレス'"
                        v-model.trim="contractPerson.email">
                      <spacer :y="2"/>
                      <div :class="$style.label_wrap">
                        <p :class="$style.sub_label">住所</p>
                        <p :class="$style.required">※必須項目</p>
                      </div>
                      <!-- 組織住所（addresses）とは別インスタンス。DOM id の衝突を避けるため idPrefix を渡す
                           （渡さないと id="zip" 等が重複し label クリックが先頭インスタンスへ吸われる）。
                           items は Address 側では読み取り専用の定義配列なので組織住所と同じものを共有する。
                           こちらは v-for の外なので $refs.cpAddress は配列にならない（組織住所側は配列）。 -->
                      <Address
                        @sendValue="receiveContractPersonValue"
                        :items="items"
                        :isConfirm="flag.isConfirm"
                        idPrefix="cp"
                        ref="cpAddress" />
                    </div>
                  </div>
                </div>
              </div>
              <spacer :y="5"/>
              <btn-container>
                <basic-btn
                  tag="button"
                  v-if="!flag.isConfirm"
                  v-on:click="changeFlag">入力内容を確認する</basic-btn>
                <basic-btn
                  tag="button"
                  v-if="flag.isConfirm"
                  v-on:click="changeFlag">編集画面に戻る</basic-btn>
                <spacer :x="2"/>
                <basic-btn
                  tag="button"
                  v-if="flag.isConfirm"
                  v-on:click="update">入力内容を確定する</basic-btn>
              </btn-container>
            </div>
          </loader-simple>
        </contents-box>
      </stack-item>

      <stack-item v-if="flag.csvForm">
        <contents-box title="利用者CSVインポート">
          <p>※CSVリストに空欄や不要データがある場合、該当行はスキップされ仮登録されません<br>「csvファイル名:ファイル送信日(弊社お受取日)_学園名_学校名_アカウント数_学年<br>例:230906_wtt_sussakurahighschool_350_2」 ※全て英数半角</p>
          <div
            :class="$style.read_csv"
            v-on:dragover="dragover"
            v-on:drop="updateFile"
            style="margin-top: 0.8em;">
            <input
              :class="$style.file_input"
              type="file"
              id="file"
              accept=".csv"
              v-on:change="updateFile">
            <p :class="$style.assistance">ドラッグ＆ドロップでもファイルを追加できます</p>
          </div>
          <div v-if="usersFile">
            <spacer :y="3" />
            <p :class="$style.file_name">{{ planeFileName }}</p>
            <spacer :y="2"/>
            <btn-container>
              <basic-btn
                tag="button"
                v-on:click="registSchoolList">登録する</basic-btn>
              <spacer :x="3"/>
              <basic-btn
                tag="button"
                v-on:click="deleteSchoolList">キャンセル</basic-btn>
            </btn-container>
          </div>
        </contents-box>
        <spacer :y="3"/>

        <contents-box title="メール配信制御">
          <div :class="$style.userCounts">
            <dl>
              <dt>本登録</dt>
              <dd>{{ userCounts.registed }} / <span>{{ userCounts.registed + userCounts.unregist }}</span></dd>
            </dl>
            <dl>
              <dt>仮登録</dt>
              <dd>{{ userCounts.unregist }} / <span>{{ userCounts.registed + userCounts.unregist }}</span></dd>
            </dl>
          </div>
          <spacer :y="1"/>
          <p :class="$style.assistance">該当のcsvファイルを選択し、「本登録お願いメール」または「リマインドメール」を配信します。</p>
          <p :class="$style.assistance">登録お願いメールはcsvリスト全員に配信が完了すると実行できなくなります。<br>リマインドメールは(本登録が済んでいない)仮登録者に配信されます。<br> ※リマインドメールは、配信時の仮登録者全てに、実行のたびに送信されます。</p>
          <p
            v-if="school.lti"
            :class="[$style.assistance, $style.danger]">※LTI対応校は仮登録者のメールアドレスを登録していないため、メール配信制御は行えません。</p>
          <spacer :y="1"/>
          <div :class="$style.selectCSV">
            <select
              :class="$style.select"
              v-model="selectedFilename"
              @change="getRemindFailedCount">
              <option :value="0">csvファイルを選択してください</option>
              <option
                v-for="n in importFiles"
                :key="n"
                :value="n">{{ n.name }}</option>
            </select>
            <div
              :class="$style.notes"
              v-if="selectedFilename && countFailedActivate">
              <spacer :y="1"/>
              <p :class="$style.bold">本登録メール送信失敗: {{ countFailedActivate }}件</p>
              <p>再度「本登録お願いメール送信」を実行してください。失敗した利用者さまにのみメールが送信されます。</p>
            </div>
            <div
              :class="$style.notes"
              v-if="selectedFilename && failedReminds.length">
              <spacer :y="1"/>
              <p :class="$style.bold">リマインドメール送信失敗: {{ failedReminds.length }}件</p>
              <p>「リマインドメール再送信」を実行してください。以下利用者さまにのみリマインドメールが送信されます。</p>
              <spacer :y="1"/>
              <ul>
                <li v-for="row in failedReminds"
                  :key="row.id">{{ row.targetUser.customer_id }} {{ row.targetUser.username }}</li>
              </ul>
            </div>

            <div
              :class="$style.remind_history"
              v-if="selectedFilename && selectedFilename.importRemind.length">
              <spacer :y="2" />
              <p :class="$style.unregistered">リマインドメール送信履歴</p>
              <table>
                <tr>
                  <td>送信日時</td>
                  <td :class="$style.remind_history_row">送信件数</td>
                </tr>
                <tr v-for="row in selectedFilename.importRemind" :key="row">
                  <td>{{ fromatDay(row.updated_at) }}</td>
                  <td :class="$style.remind_history_row">{{ row.target_count }} / <span>{{ selectedFilename.users.length }}</span>件</td>
                </tr>
              </table>
            </div>
          </div>
          <spacer :y="1" v-if="flag.isNoneTemporaries" />
          <div v-if="flag.isNoneTemporaries" :class="$style.notes"><p :class="$style.bold">選択したcsvファイルの利用者はすべて本登録が完了しています。</p></div>
          <spacer :y="2"/>
          <btn-container>
            <basic-btn
              tag="button"
              :disabled="(!selectedFilename || countFailedActivate === false) || school.lti"
              v-on:click="activate(selectedFilename.users)">本登録お願いメール</basic-btn>
            <spacer :x="2"/>
            <basic-btn
              tag="button"
              :disabled="(!selectedFilename || failedReminds.length) || flag.isNoneTemporaries || school.lti"
              v-on:click="unregistCheck(selectedFilename.users)">リマインドメール</basic-btn>
            <spacer :x="2" v-if="selectedFilename || failedReminds.length" />
            <basic-btn
              tag="button"
              v-if="selectedFilename && failedReminds.length"
              @click="resendRemind">リマインドメール再送信</basic-btn>
          </btn-container>

          <div v-if="unregistUsers.length">
            <spacer :y="2"/>
            <p :class="$style.unregistered">仮登録者リスト ダウンロード</p>
            <spacer :y="1"/>
            <p :class="$style.assistance">上記の選択csvファイルのうち、現時点での仮登録者リストをダウンロードします。</p>
            <spacer :y="2"/>
            <btn-container>
              <basic-btn
                tag="a"
                :href="downloadUrl"
                :download="fileName"
                :class="[$style.downloadBTN, !selectedFilename || flag.isNoneTemporaries ? $style.disabled : '']">ダウンロード</basic-btn>
            </btn-container>
          </div>

          </contents-box>
      </stack-item>

      <!-- アカウント課金 -->
      <stack-item v-if="school && school.billing_type && billing_type === 'account'">
        <contents-box title="インポートcsv 利用回数">
          <p :class="$style.assistance">選択したCSVファイルに紐づく利用者の利用可能回数を一括で調整できます。<br>
            ※デフォルト回数　心理士10回/医師2回<br>
            ※年度末3/31に自動的リセット（契約始期に問わず）<br>
            ※CSVファイルを選択せず追加を行うと組織に所属する利用者全員に一括で編集を行えます
          </p>

          <spacer :y="2" />
          <div :class="$style.flex_elem">
            <b>調整履歴</b>
            <spacer :x="1" />
            <p
              v-if="!flag.openBulkCountHistory"
              :class="$style.icon_gray"
              @click="changeOpenBulkCountHistory"><i class="fa-solid fa-plus"></i></p>
            <p
              v-if="flag.openBulkCountHistory"
              :class="$style.icon_gray"
              @click="changeOpenBulkCountHistory"><i class="fa-solid fa-minus"></i></p>
          </div>
          <div v-if="flag.openBulkCountHistory">
            <spacer :y="3" />
            <div v-if="!bulkCountHistorys.length">調整履歴はありません</div>
            <div v-else :class="[$style.categories, $style.max_width]">
              <dl :class="$style.category">
                <dt>編集日</dt><dt>医師・心理士分類</dt><dt>内容</dt><dt>範囲</dt>
              </dl>
              <!-- <dl :class="[$style.category, $style.pointer]"
                @click="jumpUserList(history.import_file)"
                v-for="history in bulkCountHistorys" :key="history"> -->
              <dl :class="$style.category"
                v-for="history in bulkCountHistorys" :key="history">
                <dd v-for="data in Object.values(history)" :key="data">
                  <p :class="$style.width_break">{{ data }}</p>
                </dd>
              </dl>
            </div>
            <spacer :y="3" />
          </div>

          <spacer :y="2"/>
          <div :class="$style.flex_elem">
            <select
              :class="$style.select"
              v-model="creditTargetFile"
              @change="updateCreditTargets">
              <option :value="null">選択してください</option>
              <option :value="0">全体</option>
              <option
                v-for="n in importFiles"
                :key="n"
                :value="n">{{ n.name }}</option>
            </select>
            <spacer :x="8" />
            <limit-counter
            :flag="flag"
            :school="school"
            :isOperator="true"
            :isBulkEdit="true"
            @updateTarget="updateTargetCount"
            :targetFile="creditTargetFile"
            :creditTarget="creditTargets" />
          </div>
        </contents-box>
      </stack-item>

      <!-- 学校へのクレジットは共通 -->
      <stack-item v-if="school">
        <contents-box title="オンライン健康相談" icon="<i class='fa-solid fa-coins'></i>">
          <loader-simple :flag="flag.loader">
            <div
              :class="$style.label_wrap"
              v-if="school">
              <p :class="$style.assistance">組織が購入したクレジットを付与します</p>
            </div>
            <spacer :y="2"/>

            <div :class="$style.label_wrap">
              <p :class="$style.label">オンライン・バーチャル　保有クレジット: {{ this.schoolCredit }}</p>
            </div>
            <spacer :y="2"/>

            <div v-if="!flag.loader">
              <div :class="$style.count">
                <input
                  :class="$style.text_count"
                  name="count"
                  :disabled="flag.isConfirm"
                  v-model="credit"
                  placeholder="クレジットを入力"
                  type="number"
                  min="1">
                <spacer :y="2"/>
                <p :class="$style.label">クレジット</p>
                <spacer :y="4"/>
                <basic-btn
                  tag="button"
                  @click="setCredit(1)">追加</basic-btn>
                <spacer :y="4"/>
                <basic-btn
                  tag="button"
                  addClass="danger"
                  @click="setCredit(0)">削除</basic-btn>
              </div>
            </div>
          </loader-simple>
          <div v-if="school && school.billing_type && billing_type === 'account'">
            <spacer :y="5" />
            <div :class="$style.label_wrap">
              <p :class="$style.label">個人を対象にクレジットを編集します</p>
            </div>
            <p :class="$style.assistance">※組織の保有クレジットには影響しません</p>
            <spacer :y="2" />
            <limit-counter
              :flag="flag"
              :school="school"
              :creditTarget="creditTargets"
              :isOperator="true"
              :sustainableAddCreditHistory="true"
              @updateTarget="regetTargets" />
            <spacer :y="2"/>
            <div :class="$style.sortBox">
              <div :class="$style.top">
                <div :class="$style.search_wrap">
                  <word-search-form
                    :class="$style.search_word"
                    v-on:sendValue="wordReceiveValue"
                    :placeholder="isCompany ? '利用者を検索' : '生徒を検索'" />
                  <div :class="$style.search_button">
                    <basic-btn
                      tag="button"
                      @click="getUsers()">検索</basic-btn>
                  </div>
                </div>
                <div v-if="!isCompany" :class="$style.birth">
                  <spacer :y="2" />
                  <dl>
                    <dt><i class="fa-solid fa-graduation-cap"></i>学年</dt>
                    <dd>
                      <div>
                        <select
                          :class="$style.select_box"
                          v-model="schoolYear"
                          name="schoolYear"
                          id="schoolYear"
                          @change="updateSchoolYear">
                          <option :value="null">選択なし</option>
                          <option
                            v-for="n of setSchoolYear()"
                            :key="n"
                            :value="n">{{ n }}</option>
                        </select>
                      </div>
                    </dd>
                  </dl>
                </div>
                <div v-if="flag.exeSearch">
                <div>
                  <spacer :y="2"/>
                  <input type="checkbox" id="bulkChek" v-model="bulkChek">
                  <label for="bulkChek">一括チェック</label>
                  <spacer :y="2"/>
                </div>
                <stack-item v-for="row in creditTargets" :key="row.id">
                  <div :class="$style.check_user">
                    <input
                      :class="$style.user_check_box"
                      type="checkbox"
                      :id="`checked_${row.id}`"
                      :value="row.id"
                      v-model="creditTargetIds"
                      @change="updateTargets" />
                    <label
                      :for="`checked_${row.id}`"
                      :class="$style.check_user_box">
                      <user-box
                        :showId="true"
                        :showCocomoniBtn="true"
                        :ownUser="user"
                        v-if="users.length"
                        :user="row"
                        saveTab="students"
                        :bg="userBoxColor(row)">
                      </user-box>
                    </label>
                  </div>
                </stack-item>
                <stack-item v-for="row in filteredUsers" :key="row.id">
                  <div :class="$style.check_user">
                    <input
                      :class="$style.user_check_box"
                      type="checkbox"
                      :id="`stillCheck_${row.id}`"
                      :value="row.id"
                      v-model="creditTargetIds"
                      @change="updateTargets" />
                    <label
                      :for="`stillCheck_${row.id}`"
                      :class="$style.check_user_box">
                      <user-box
                        :showId="true"
                        :showCocomoniBtn="true"
                        :ownUser="user"
                        v-if="users.length"
                        :user="row"
                        saveTab="students"
                        :bg="userBoxColor(row)">
                      </user-box>
                    </label>
                  </div>
                </stack-item>
              </div>
              </div>
            </div>
          </div>
        </contents-box>
      </stack-item>

      <stack-item v-if="school && school.billing_type?.billing_type === 1">
        <contents-box title="テキスト健康相談" icon="<i class='fa-sharp fa-light fa-abacus'></i>">
          <loader-simple :flag="flag.loader">
            <div
              :class="$style.label_wrap"
              v-if="school">
              <p :class="$style.assistance">組織が購入したテキスト利用回数を付与します</p>
            </div>
            <spacer :y="2"/>

            <div :class="$style.label_wrap">
              <p :class="$style.label">テキスト　利用可能回数: {{ this.schoolTextCredit }}</p>
            </div>
            <spacer :y="2"/>

            <div v-if="!flag.loader">
              <div :class="$style.count">
                <input
                  :class="$style.text_count"
                  name="count"
                  :disabled="flag.isConfirm"
                  v-model="textCredit"
                  placeholder="カウントを入力"
                  type="number"
                  min="1">
                <spacer :y="2"/>
                <p :class="$style.label">回</p>
                <spacer :y="4"/>
                <basic-btn
                  tag="button"
                  @click="setTextCredit(1)">追加</basic-btn>
                <spacer :y="4"/>
                <basic-btn
                  tag="button"
                  addClass="danger"
                  @click="setTextCredit(0)">削除</basic-btn>
              </div>
            </div>
          </loader-simple>
        </contents-box>
      </stack-item>

      <stack-item>
        <contents-box title="管理者情報">
          <loader-simple :flag="flag.loader">
            <div v-if="!flag.loader">
              <ul :class="$style.users">
                <li
                  v-for="user in school.mainUser"
                  :key="user.id">
                  <div :class="$style.user_wrap">
                    <contents-box type="inner">
                      <div v-if="mainValues.id !== user.id">
                        <ul :class="$style.user">
                          <li
                            v-for="item in userItems"
                            :key="item.name"
                            v-show="item.name !== 'kana'">
                            <p :class="$style.user_value" v-if="getMainUserField(user, item.name)">
                              <i :class="item.icon"/>
                              <span v-if="item.isSchoolAdminField">{{ item.label }}: </span>
                              {{ getMainUserField(user, item.name) }}<span v-if="item.name === 'username' && user.kana">（{{ user.kana }}）</span>
                            </p>
                            <p :class="$style.user_value" v-else><i :class="item.icon"/>登録なし</p>
                          </li>
                        </ul>
                        <spacer :y="2"/>
                        <btn-container align="right">
                          <basic-btn
                            tag="button"
                            size="sm"
                            v-on:click="editStart(user, 'main')">編集</basic-btn>
                        </btn-container>
                      </div>
                      <div v-else>
                        <ul>
                          <li
                            v-for="item in userItems"
                            :key="item.name">
                            <div :class="$style.label_wrap">
                              <p :class="$style.label">{{ item.label }}<span v-if="item.required" :class="$style.required_mark">※必須</span></p>
                            </div>
                            <div :class="$style.detail">
                              <input
                                v-if="item.name === 'email'"
                                :class="$style.text"
                                id="mainUser"
                                type="email"
                                name="mainUser"
                                v-model.trim="$v.mainUser.$model"
                                v-model="mainValues[item.name]">
                              <input
                                v-else-if="item.name === 'kana'"
                                type="text"
                                v-model.trim="mainValues[item.name]"
                                @compositionend="onUserKanaBlur('main')"
                                @blur="onUserKanaBlur('main')"
                                :class="$style.text">
                              <input
                                v-else
                                type="text"
                                v-model="mainValues[item.name]"
                                :placeholder="item.isSchoolAdminField ? item.placeholder : ''"
                                :class="$style.text">
                              <p v-if="item.name === 'email'
                                && $v.mainUser.$dirty
                                && $v.mainUser.email.$invalid"
                                :class="$style.required">正しいメールアドレスの形式で入力してください</p>
                              <p v-if="item.name === 'kana' && mainKanaInvalid"
                                :class="$style.required">カナ文字のみ入力してください</p>
                            </div>
                          </li>
                        </ul>
                        <spacer :y="2"/>
                        <btn-container>
                          <basic-btn
                            tag="button"
                            size="sm"
                            v-on:click="updateUser('main')">更新</basic-btn>
                          <spacer :x="2"/>
                          <basic-btn
                            tag="button"
                            size="sm"
                            type="bdr"
                            v-on:click="editCancel('main')">戻る</basic-btn>
                        </btn-container>
                      </div>
                    </contents-box>
                  </div>
                </li>
              </ul>
            </div>
          </loader-simple>
        </contents-box>
      </stack-item>
      <stack-item>
        <contents-box title="副管理者情報">
          <loader-simple :flag="flag.loader">
            <div v-if="!flag.loader">
              <p :class="$style.helper_text">※ 副管理者は最大 {{ subAdminLimit }} 名まで登録できます</p>
              <ul :class="$style.users">
                <li
                  v-for="row in mergedSubUsers"
                  :key="`${row._source}-${row.id}`">
                  <div :class="$style.user_wrap">
                    <contents-box type="inner">
                      <div v-if="editingSubKey !== `${row._source}-${row.id}`">
                        <ul :class="$style.user">
                          <li
                            v-for="item in userItems"
                            :key="item.name"
                            v-show="item.name !== 'kana' && !(item.isSchoolAdminField && row._source === 'subUsers') && !(item.name === 'department' && row._source === 'users' && isSubDepartmentHidden)">
                            <p :class="$style.user_value" v-if="row[item.name]">
                              <i :class="item.icon"/>
                              <span v-if="item.isSchoolAdminField">{{ item.label }}: </span>
                              {{ row[item.name] }}<span v-if="item.name === 'username' && row.kana">（{{ row.kana }}）</span>
                              <span
                                v-if="item.name === 'username'"
                                :class="$style.status_badge_wrap">
                                <span :class="[$style.status_badge, $style[`status_${row.loginStatus}`]]">{{ loginStatusLabel(row.loginStatus) }}</span>
                                <span :class="$style.status_hint">
                                  <i class="fa-regular fa-circle-question" :class="$style.status_hint_icon"></i>
                                  <span :class="$style.status_tooltip">{{ loginStatusDetail(row.loginStatus) }}</span>
                                </span>
                              </span>
                            </p>
                            <p :class="$style.user_value" v-else>
                              <i :class="item.icon"/>登録なし
                              <span
                                v-if="item.name === 'username'"
                                :class="$style.status_badge_wrap">
                                <span :class="[$style.status_badge, $style[`status_${row.loginStatus}`]]">{{ loginStatusLabel(row.loginStatus) }}</span>
                                <span :class="$style.status_hint">
                                  <i class="fa-regular fa-circle-question" :class="$style.status_hint_icon"></i>
                                  <span :class="$style.status_tooltip">{{ loginStatusDetail(row.loginStatus) }}</span>
                                </span>
                              </span>
                            </p>
                          </li>
                        </ul>
                        <spacer :y="2"/>
                        <btn-container align="right">
                          <basic-btn
                            tag="button"
                            size="sm"
                            v-on:click="editStart(row, 'sub')">編集</basic-btn>
                          <template v-if="row._source === 'subUsers' || (row._source === 'users' && !row.has_password)">
                            <spacer :x="2"/>
                            <basic-btn
                              tag="button"
                              size="sm"
                              type="bdr"
                              v-on:click="sendPasswordSetupLink(row)">ログイン有効化リンクを送信</basic-btn>
                          </template>
                        </btn-container>
                        <template v-if="(row._source === 'subUsers' || (row._source === 'users' && !row.has_password)) && row.last_link_sent_at">
                          <p :class="$style.last_link_sent">前回送信: {{ row.last_link_sent_at }}</p>
                        </template>
                      </div>
                      <div v-else>
                        <ul>
                          <li
                            v-for="item in subUserItems"
                            :key="item.name"
                            v-show="!(item.isSchoolAdminField && subValues._source === 'subUsers')">
                            <div :class="$style.label_wrap">
                              <p :class="$style.label">{{ item.label }}<span v-if="item.required" :class="$style.required_mark">※必須</span></p>
                            </div>
                            <div :class="$style.detail">
                              <input
                                v-if="item.name === 'email'"
                                type="email"
                                id="subUser"
                                name="subUser"
                                v-model.trim="$v.subUser.$model"
                                v-model="subValues[item.name]"
                                :class="$style.text">
                              <input
                                v-else-if="item.name === 'kana'"
                                type="text"
                                v-model.trim="subValues[item.name]"
                                @compositionend="onUserKanaBlur('sub')"
                                @blur="onUserKanaBlur('sub')"
                                :class="$style.text">
                              <input
                                v-else
                                type="text"
                                v-model="subValues[item.name]"
                                :placeholder="item.isSchoolAdminField ? item.placeholder : ''"
                                :class="$style.text">
                              <p v-if="item.name === 'email'
                                && $v.subUser.$dirty
                                && $v.subUser.email.$invalid"
                                :class="$style.required">正しいメールアドレスの形式で入力してください</p>
                              <p v-if="item.name === 'kana' && subKanaInvalid"
                                :class="$style.required">カナ文字のみ入力してください</p>
                            </div>
                          </li>
                        </ul>
                        <!-- レガシー subUsers は職階(schoolAdmins)の保存先を持たないため、ログイン有効化リンク送信(=users移管)後にのみ設定可能 -->
                        <p v-if="subValues._source === 'subUsers'" :class="$style.last_link_sent">{{ schoolAdminFieldsLabel }}はログイン有効化リンクを送信後に設定できます。</p>
                        <!-- 重複等のエラーは編集中フォーム内に表示し、どの副管理者のエラーか紐付ける -->
                        <p v-if="subErrorMessage" :class="$style.required">{{ subErrorMessage }}</p>
                        <spacer :y="2"/>
                        <btn-container>
                          <basic-btn
                            tag="button"
                            size="sm"
                            v-on:click="updateUser('sub')">更新</basic-btn>
                          <spacer :x="2"/>
                          <basic-btn
                            tag="button"
                            size="sm"
                            type="bdr"
                            v-on:click="editCancel('sub')">戻る</basic-btn>
                          <spacer :x="2"/>
                          <basic-btn
                            tag="button"
                            size="sm"
                            addClass="danger"
                            v-on:click="deleteSubUser('sub')">削除</basic-btn>
                        </btn-container>
                      </div>
                    </contents-box>
                  </div>
                </li>
                <li v-if="!subAdminLimitReached">
                  <div :class="$style.user_wrap">
                    <contents-box type="inner">
                      <div v-if="!flag.registSubUser">
                        <basic-btn
                          tag="button"
                          size="sm"
                          v-on:click="editStart(null, 'sub')">副管理者を追加</basic-btn>
                      </div>
                      <div v-else>
                        <ul>
                          <li
                            v-for="item in subUserItems"
                            :key="item.name">
                            <div :class="$style.label_wrap">
                              <p :class="$style.label">{{ item.label }}<span v-if="item.required" :class="$style.required_mark">※必須</span></p>
                            </div>
                            <div :class="$style.detail">
                              <input
                                v-if="item.name === 'kana'"
                                type="text"
                                v-model.trim="subValues[item.name]"
                                @compositionend="onUserKanaBlur('sub')"
                                @blur="onUserKanaBlur('sub')"
                                :class="$style.text">
                              <input
                                v-else
                                type="text"
                                v-model="subValues[item.name]"
                                :placeholder="item.isSchoolAdminField ? item.placeholder : ''"
                                :class="$style.text">
                              <p v-if="item.name === 'kana' && subKanaInvalid"
                                :class="$style.required">カナ文字のみ入力してください</p>
                            </div>
                          </li>
                        </ul>
                        <!-- 重複等のエラーは追加中フォーム内に表示し、入力値を保持したまま訂正できるようにする -->
                        <p v-if="subErrorMessage" :class="$style.required">{{ subErrorMessage }}</p>
                        <spacer :y="2"/>
                        <btn-container>
                          <basic-btn
                            tag="button"
                            size="sm"
                            v-on:click="updateUser('sub')">登録</basic-btn>
                          <spacer :x="2"/>
                          <basic-btn
                            tag="button"
                            size="sm"
                            type="bdr"
                            v-on:click="editCancel('sub')">戻る</basic-btn>
                        </btn-container>
                      </div>
                    </contents-box>
                  </div>
                </li>
              </ul>
            </div>
          </loader-simple>
        </contents-box>
      </stack-item>
      <!-- 学年未登録者ダウンロード -->
<!--
      <stack-item>
        <unregist-school-year
          :school="school"/>
      </stack-item>
-->
    </ul>
    <spacer :y="8.5"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import { Address } from '@/views/components/parts/Form';
import Spacer from '@/views/components/Spacer.vue';
import LimitCounter from '@/views/components/LimitCounter4BillingAccount.vue';
import WordSearchForm from '@/views/components/WordSearchForm.vue';
import UserBox from '@/views/components/UserBox.vue';
import PrevBtn from '@/views/components/PrevBtn.vue';
// import UnregistSchoolYear from '@/views/components/UnregistSchoolYear.vue';
import cf from '@/mixins/commonFunctions.js';
import saf from '@/mixins/schoolAdminFunctions';
import csm from '@/mixins/corporateSchool';
import moment from 'moment';
import { normalizeKana, isValidKana } from '@/lib/normalizeKana';
import { toISODateString } from '@/lib/dateParts';

// フォーム項目のグループ定義（罫線の括り単位）。住所ブロック（parts/Form/Address.vue）と同じ
// 「1 罫線の中に関連項目をまとめる」表現を他項目へ展開するためのもの。登録画面（Register/RegistSchool.vue）と同型。
// - members は描画順で並べる。先頭/中間/最終は「そのとき可視な member」から動的に決めるため、
//   可変表示（企業/インターンで学校タイプ非表示）で罫線が消えたり下余白が詰まったりしない。
//   本画面の可視制御は v-show（非表示行も DOM に残る）なので、CSS の :first-child / :last-child では
//   先頭・最終を判定できず、この JS 側の可視行リストが唯一の判定源になる。
// - promoted: 見出しに昇格させる既存ラベルを持つ行名（新語を増やさない）。本画面は全グループが promoted＝
//   見出しは昇格ラベルが兼ねるため、見出し行を描画する仕組みは持たない（登録画面の「管理者情報」のような
//   新語見出しを本画面に足すときは、登録画面の rowGroupHeading と group_heading を移植する）。
// - indented: 見出しの選択に従属する子行（契約プラン配下の「パターン種別」と同じ 1em の字下げを付ける）。
// 管理者情報/副管理者は本画面では別 contents-box で既に罫線なしのため対象外（登録画面のみ G3/G4 を持つ）。
const FIELD_GROUPS = [
  {
    name: 'orgType',
    promoted: 'orgType',
    members: ['orgType', 'school_type'],
    indented: ['school_type'],
  },
  // サイト表示名（schools.name / kana）。法人名（schools.corporate_name / corporate_kana）は契約担当者
  // ブロック内で描画するため、どのグループにも属さない（罫線グループの仕組みを使わない）。
  {
    name: 'siteName', promoted: 'name', members: ['name', 'kana'],
  },
];

export default {
  name: 'operator-updateSchool',
  mixins: [cf, saf, csm],
  components: {
    BasicBtn,
    BtnContainer,
    StackItem,
    ContentsBox,
    LoaderSimple,
    Spacer,
    Address,
    LimitCounter,
    WordSearchForm,
    UserBox,
    PrevBtn,
    // UnregistSchoolYear,
  },
  data() {
    return {
      mainKanaInvalid: false,
      subKanaInvalid: false,
      flag: {
        loader: true,
        isConfirm: false,
        readySubmit: false,
        // 契約担当者住所（Address の 2 インスタンス目）のサブミット可否。組織住所の readySubmit とは別枠で持つ。
        readySubmitContractPerson: false,
        registSubUser: false,
        csvForm: false,
        changeSchoolMemo: false,
        openBulkCountHistory: false,
        isNoneTemporaries: false, // 仮登録者なしフラグ
      },
      validationFlags: {
        mailUser: false,
        mainUser: false,
        subUser: false,
      },
      invalids: {
        mailUser: true,
        mainUser: true,
        subUser: true,
        kana: false,
        siteKana: false,
      },
      school: null,
      schoolYear: null,
      searchSchoolYear: null, // 学年検索機能追加のため
      features: null,
      schoolMemo: null,
      billing_type: 'default',
      // 読み込んだ時点の契約プラン（1=スポット / 2=サステナブル）。画面で選び直しても変わらない
      // （billingPlanOptions が「すでにサステナブルの企業」を見分けるのに使う）
      savedBillingType: null,
      usersFile: null,
      userList: [],
      creditTargetFile: null,
      creditTargets: [],
      creditTargetIds: [],
      bulkCountHistorys: [],
      bulkChek: false,
      registSituation: {
        completion: [],
        temporary: [],
      },
      courseOptions: {
        account: [
          {
            name: 'account-1',
            label: '心理士 年10回',
            value: 1,
          },
          {
            name: 'account-2',
            label: '医師　年２回',
            value: 2,
          },
        ],
      },
      // 組織区分は3カラム（is_company/is_corporate/school_type）で DB 保持。更新画面では
      // read-only（編集不可）で、既存値から導出した単一「組織タイプ」3区分を読み取り表示する。
      is_company: 0,
      is_corporate: 0,
      // UI 用の単一セレクタ（read-only 表示）。0=学校(0,0) / 1=インターン(1,0) / 2=企業(1,1)。
      orgType: 0,
      organizationTypes: [
        {
          // 更新画面では編集不可（template で :disabled="true"）・既存値の読み取り表示のみ。
          type: 'radio',
          name: 'orgType',
          label: '組織タイプ',
          required: true,
          value: 0,
          options: [
            {
              name: 'orgSchool',
              label: '学校',
              value: 0,
            },
            {
              name: 'orgIntern',
              label: 'インターン',
              value: 1,
            },
            {
              name: 'orgCompany',
              label: '企業',
              value: 2,
            },
          ],
        },
      ],
      contents: [
        // contents[0]は課金モデルで固定
        {
          type: 'radio',
          name: 'billing_type',
          label: '契約プラン',
          required: true,
          value: 1,
          datatype: 2,
          options: [
            {
              name: 'default',
              label: 'スポットプラン',
              value: 1,
            },
            {
              name: 'account',
              label: 'サステナブルプラン',
              value: 2,
            },
          ],
        },
        {
          type: 'radio',
          name: 'school_type',
          label: '学校タイプ',
          required: true,
          value: 1,
          datatype: 1,
          options: [
            {
              name: 'elementary',
              label: '小学校',
              value: 1,
            },
            {
              name: 'juniorHigh',
              label: '中学校',
              value: 2,
            },
            {
              name: 'high',
              label: '高校',
              value: 3,
            },
            {
              name: 'univ',
              label: '専門・短大・大学',
              value: 4,
            },
            {
              name: 'free',
              label: 'フリースクール',
              value: 5,
            },
            {
              name: 'personal',
              label: '個人向け',
              value: 0,
            },
          ],
        },
        {
          // 法人名（契約主体の名称）。主ループでは描画せず、契約担当者ブロック内で描画する
          // （orderedContents で除外）。行自体は残す＝送信経路 datatype:1 は不変。
          // ラベルは全組織タイプ共通のため cplaceholder による出し分けは持たない。
          type: 'text',
          name: 'corporate_name',
          label: '法人名',
          required: true,
          placeholder: '例：〇〇学園／〇〇株式会社',
          value: '',
          datatype: 1,
        },
        {
          type: 'text',
          name: 'corporate_kana',
          label: '法人名カナ',
          required: true,
          placeholder: '例：◯◯ガクエン／◯◯カブシキガイシャ',
          value: '',
          datatype: 1,
        },
        {
          // サイト表示名（利用者・学校管理者のヘッダーに看板として出す名称）
          type: 'text',
          name: 'name',
          label: 'サイト表示名',
          required: true,
          placeholder: '例：〇〇高校',
          cplaceholder: '例：〇〇株式会社',
          value: '',
          datatype: 1,
        },
        {
          type: 'text',
          name: 'kana',
          // 「サイト表示名」グループの子行。見出し（サイト表示名）と重ねて読ませるためラベルは短縮する
          label: 'カナ',
          required: true,
          placeholder: '例：◯◯コウコウ',
          cplaceholder: '例：◯◯カブシキガイシャ',
          value: '',
          datatype: 1,
        },
        {
          type: 'text',
          name: 'tel',
          label: '電話番号',
          required: true,
          assistant: '半角・ハイフンなしで入力してください',
          value: '',
          datatype: 1,
        },
        // {
        //   type: 'text',
        //   name: 'fax',
        //   label: 'fax',
        //   value: '',
        //   datatype: 1,
        // },
      ],
      items: [
        {
          name: 'zip',
          type: 'text',
          label: '郵便番号',
          value: null,
          required: true,
          placeholder: '1020074',
          comment: '半角・ハイフンなしで入力してください',
        },
        {
          name: 'pref',
          type: 'select',
          label: '都道府県',
          value: null,
          options: [],
          required: true,
          comment: '',
        },
        {
          name: 'city',
          type: 'text',
          label: '市区町村',
          value: null,
          required: true,
          placeholder: '千代田区九段南',
        },
        {
          name: 'address',
          type: 'text',
          label: '番地',
          value: null,
          required: true,
          placeholder: '1-2-3',
        },
        {
          name: 'building',
          type: 'text',
          label: '建物名・部屋番号（任意）',
          value: null,
          required: false,
          placeholder: '〇〇ビル 4F',
        },
      ],
      address: {},
      schoolID: null,
      // 契約担当者（氏名/カナ/部署/職階/メール/電話）。ON/OFF は schools.contract_same_as_admin
      // から復元し、入力欄の初期値は contractPerson 行があればその実値を写す
      // （ASK-7：is-corporate 以前の既存校は行なしが正常状態）。
      // 「管理者と同一」ON の間は contractPersonData を送らず、backend 側で既存行が削除される。
      contractPerson: {
        sameAsAdmin: true,
        name: '',
        kana: '',
        department: '',
        position: '',
        email: '',
        tel: '',
      },
      // 契約担当者の住所（送信用バッファ）。組織住所の address と同じ役割で、Address からの
      // sendValue emit を受けて溜めるだけ。既存値の prefill 元は school.contractPerson 側なので
      // ここに DB 値を控えない（控えると子の初期 emit に上書きされて prefill が空振りする）。
      contractPersonAddress: {},
      measuredDatas: [
        {
          inputType: 'text',
          label: '契約名',
          name: 'contractName',
          value: null,
          required: false,
        },
        {
          inputType: 'number',
          label: '契約年月日',
          name: 'contractDate',
          values: {
            year: null,
            month: null,
            day: null,
          },
          required: true,
        },
        {
          cycle: [
            {
              label: '月次パターン',
              value: 1,
              checked: true,
            },
            {
              label: '年次パターン',
              value: 2,
              checked: false,
            },
          ],
          inputType: 'radio',
          label: 'パターン種別',
          naem: 'cycle',
          value: null,
          required: true,
        },
        {
          inputType: 'number',
          label: 'テキスト基本回数',
          name: 'textDefaultCount',
          value: null,
          required: true,
        },
        // {
        //   inputType: 'number',
        //   label: 'オンライン基本回数',
        //   naem: 'onlineDefaultCount',
        //   value: null,
        //   required: true,
        // },
      ],
      mainValues: {
        id: null,
        username: null,
        kana: null,
        email: null,
        department: null,
        position: null,
        role: null,
      },
      subValues: {
        id: null,
        username: null,
        kana: null,
        email: null,
        department: null,
        position: null,
        role: null,
        _source: null,
      },
      editingSubKey: null,
      subErrorMessage: null,
      updateCount: null,
      unregistUsers: [],
      downloadUrl: null,
      fileName: null,
      planeFileName: null,
      credit: null,
      textCredit: null,
      selectedFilename: 0,
      importFiles: null,
      defectColumn: [],
      userCounts: {
        unregist: 0,
        registed: 0,
      },
      failedReminds: [],
    };
  },
  setup() {
    const mainUser = ref('');
    const subUser = ref('');
    // kana = 法人名カナ（schools.corporate_kana） / siteKana = サイト表示名カナ（schools.kana）
    const kana = ref('');
    const siteKana = ref('');

    // カタカナ・半角スペース・全角スペースのみ許す
    const kanaTextRule = (value) => /^[ァ-ヶー\s　]+$/u.test(value);

    const rules = {
      // メールはemail形式
      mailUser: { required, email },
      mainUser: { email },
      subUser: { email },
      kana: {
        required,
        custom: kanaTextRule,
      },
      siteKana: {
        required,
        custom: kanaTextRule,
      },
    };

    const $v = useVuelidate(rules, {
      mainUser,
      subUser,
      kana,
      siteKana,
    });

    return {
      mainUser,
      subUser,
      kana,
      siteKana,
      $v,
    };
  },
  created() {
    if (this.helper.master.prefs) {
      this.items[1].options = this.helper.master.prefs;
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'helper/putMaster') {
          this.items[1].options = mutation.payload.prefs;
        }
      });
    }
    this.schoolId = cf.convert2Num(this.$route.params.slug);
    this.getSchool();
  },
  watch: {
    /** 「管理者と同一」が OFF になった時点で契約担当者住所の入力欄がマウントされるため、
     *  描画後に既存値を流し込む。初期表示もここで賄う — data() の既定は ON なので、
     *  個別設定の組織を開くと getSchool() の代入で ON→OFF に変わり本 watcher が発火する
     *  （既定を OFF に変えると初期 prefill が発火しなくなる点に注意）。 */
    'contractPerson.sameAsAdmin': function onSameAsAdminChange(val) {
      if (!val) this.$nextTick(() => { this.applyContractPersonAddress(); });
    },
    bulkChek() {
      if (this.bulkChek) {
        this.filteredUsers.forEach((elem) => {
          this.creditTargets.push(elem);
          this.creditTargetIds.push(elem.id);
        });
      } else {
        this.creditTargets = [];
        this.creditTargetIds = [];
      }
      this.updateTargets();
    },
  },
  computed: {
    ...mapState(['user', 'helper']),
    /** 区分セレクタ UI（更新画面タイトル）の3区分ラベル。
     *  企業=(1,1)/インターン=(1,0)/学校=(0,0)。
     *  labels.organizationTypes は業務表示と共用で要件2(id=18=企業表記継続)のため触れず、
     *  ここで局所的に「企業/インターン」を出し分ける。 */
    organizationTypeLabel() {
      if (this.is_company && this.is_corporate) return '企業';
      if (this.is_company) return 'インターン';
      return '学校';
    },
    /** 契約プランの選択肢。企業はサステナブルプラン（全生徒を対象にしたアカウント課金）を契約できないので、
     *  スポットプランだけを出す。ただし、すでにサステナブルプランで登録されている企業は、今の契約が
     *  画面から消えないよう両方を出す（スポットプランへ切り替えられるように）。 */
    billingPlanOptions() {
      if (this.is_company && this.is_corporate && this.savedBillingType !== 2) {
        return this.contents[0].options.filter((opt) => opt.value === 1);
      }
      return this.contents[0].options;
    },
    subAdminLimit() {
      return 4;
    },
    /** サイト種別に応じて表示する schoolAdmins 項目（mixin 由来・種別により列数可変）。
     *  フォーム用に icon/required/isSchoolAdminField を付与（物理列順 department→position→role） */
    schoolAdminFields() {
      return this.schoolAdminFieldDefs(
        this.school && this.school.is_company,
        this.school && this.school.school_type,
      ).map((f) => ({
        ...f,
        icon: 'fa-solid fa-briefcase',
        required: true,
        isSchoolAdminField: true,
      }));
    },
    /** 表示列のラベルを「・」で連結（レガシー subUsers 案内文用） */
    schoolAdminFieldsLabel() {
      return this.schoolAdminFields.map((field) => field.label).join('・');
    },
    /** 副管理者(account_type=12)用の表示列定義。school 種別（小中高/フリースクール/個人）では所属を出さず、
     *  company/university では従来どおり所属を表示する（主管理者用の schoolAdminFields とは別 computed）。 */
    schoolAdminFieldsSub() {
      return this.schoolAdminFieldDefs(
        this.school && this.school.is_company,
        this.school && this.school.school_type,
        12,
      );
    },
    /** 描画順だけを「… 電話番号 → 住所 → サイト表示名 → サイト表示名カナ …」に
     *  組み替えた contents のシャローコピー（各行のオブジェクト参照はそのままなので v-model の束縛先は不変）。
     *  住所はテンプレ側で tel 行の反復内に描画されるため、tel の直後へ回したサイト表示名の組は住所より後ろに出る。
     *  基準は組織メールアドレス撤去まで mail 行だった。必須項目である tel へ移したので、
     *  任意項目が消えて並べ替えごと放棄される（元の contents 順に戻る）ことはない。
     *  法人名（corporate_name / corporate_kana）は契約担当者ブロック内で描画するため主ループの対象から除外する。
     *  data() の contents 自体は contents[0]（契約プラン）/contents[1]（学校タイプ）の index 参照と
     *  更新処理の datatype 振り分けが依存しているため並び替え・行削除をせず、描画側でのみ組み替える。 */
    orderedContents() {
      const afterTel = ['name', 'kana'];
      const excludeNames = ['corporate_name', 'corporate_kana'];
      const visible = this.contents.filter((row) => !excludeNames.includes(row.name));
      // 電話番号行が無い構成（将来の項目削除等）では並べ替えを諦めて元の順序をそのまま使う
      if (!visible.some((row) => row.name === 'tel')) return visible;
      const rest = visible.filter((row) => !afterTel.includes(row.name));
      const pick = (names) => names
        .map((name) => visible.find((row) => row.name === name))
        .filter((row) => row);
      const telAt = rest.findIndex((row) => row.name === 'tel');
      return [
        ...rest.slice(0, telAt + 1),
        ...pick(afterTel),
        ...rest.slice(telAt + 1),
      ];
    },
    /** 契約担当者ブロック内で描画する法人名行（contents の実体を参照＝v-model の束縛先は contents 側） */
    corporateNameRow() {
      return this.contents.find((row) => row.name === 'corporate_name');
    },
    /** 同・法人名カナ行 */
    corporateKanaRow() {
      return this.contents.find((row) => row.name === 'corporate_kana');
    },
    /** グループごとの「いま可視な member 行名」（描画順）。罫線の先頭/最終判定に使う。
     *  可視判定は行の描画条件（isRowVisible）をそのまま流用し、表示ゲートと罫線ゲートの軸をずらさない。 */
    groupVisibleMembers() {
      const map = {};
      FIELD_GROUPS.forEach((group) => {
        map[group.name] = group.members.filter((name) => {
          // 組織タイプ行は contents ではなく organizationTypes 側（常時表示）
          if (name === 'orgType') return true;
          const row = this.contents.find((r) => r.name === name);
          return !!row && this.isRowVisible(row);
        });
      });
      return map;
    },
    /** 副管理者で所属(department)列が非表示か（school 種別の副では true）。副フォーム・副一覧の所属行出し分けに使う */
    isSubDepartmentHidden() {
      return !this.schoolAdminFieldsSub.some((field) => field.name === 'department');
    },
    /** ユーザー入力項目（固定3項目 + サイト種別依存の schoolAdmins 項目）。
     *  氏名ラベルは組織の管理者/副管理者/契約担当者を扱う全画面（登録・更新・学校管理者向け組織情報）で
     *  「氏名」に統一する（利用者・カウンセラーは別エンティティのため従来どおり「名前」）。 */
    userItems() {
      return [
        {
          label: '氏名', name: 'username', icon: 'fa-solid fa-user', required: true,
        },
        {
          label: 'カナ', name: 'kana', icon: '', required: true,
        },
        {
          label: 'メールアドレス', name: 'email', icon: 'fa-regular fa-envelope', required: true,
        },
        ...this.schoolAdminFields,
      ];
    },
    /** 副管理者フォーム用の入力項目。school 種別の副では所属(department)行を除外（schoolAdminFieldsSub 由来）。
     *  company/university では所属も必須（schoolAdminFields の required:true を継承・school 種別は所属行自体が出ない）。
     *  職階/役割は従来どおり必須。※必須マーク表示はこの required に従う。 */
    subUserItems() {
      const subKeys = this.schoolAdminFieldsSub.map((field) => field.name);
      return this.userItems
        .filter((item) => !item.isSchoolAdminField || subKeys.includes(item.name));
    },
    /**
     * 副管理者一覧（subUsers 由来 + users (account_type=12) 由来 を統合）
     */
    mergedSubUsers() {
      const rows = [];
      if (!this.school) return rows;
      const now = moment();
      if (Array.isArray(this.school.subUser)) {
        this.school.subUser.forEach((s) => {
          if (s.flag !== 999 && Number(s.migrated) !== 1) {
            rows.push({
              id: s.id,
              username: s.username,
              kana: s.kana,
              email: s.email,
              department: null,
              position: null,
              role: null,
              has_password: false,
              last_link_sent_at: null, // subUsers レコードは未送信状態でのみ表示される
              // subUsers 由来は「ログイン有効化リンク未送信（通知メールのみ運用）」→ not_sent と同表示
              loginStatus: 'not_sent',
              _source: 'subUsers',
            });
          }
        });
      }
      if (Array.isArray(this.school.schoolAdmins)) {
        this.school.schoolAdmins.forEach((a) => {
          const u = a.user;
          if (u && Number(u.account_type) === 12 && Number(u.flag) === 1) {
            // has_password はバックエンドで注入される（password 自体は hidden で露出しない）
            const hasPassword = !!u.has_password;
            // ログイン状態の派生:
            //   available: password 設定済み → ログイン可能
            //   pending:   リンク送信済・期限内（activatekey 有効）
            //   expired:   リンク送信済・期限切れ（要再送）
            //   not_sent:  未送信（users 作成直後、expiry=NULL）
            let loginStatus;
            if (hasPassword) loginStatus = 'available';
            else if (u.expiry && moment(u.expiry).isAfter(now)) loginStatus = 'pending';
            else if (u.expiry) loginStatus = 'expired';
            else loginStatus = 'not_sent';
            rows.push({
              id: u.id,
              username: u.username,
              kana: u.kana,
              email: u.email,
              department: a.department || null,
              position: a.position || null,
              role: a.role || null,
              has_password: hasPassword,
              // expiry は activatekey 発行時に「now + 1 day」で設定されるため、expiry − 1 日 = 前回送信時刻
              last_link_sent_at: u.expiry ? moment(u.expiry).subtract(1, 'days').format('YYYY/MM/DD HH:mm') : null,
              loginStatus,
              _source: 'users',
            });
          }
        });
      }
      return rows;
    },
    subAdminLimitReached() {
      return this.mergedSubUsers.length >= this.subAdminLimit;
    },
    /**
     * 学校の保持オンラインクレジット
     *   該当校の課金タイプが
     *     1 => 従量課金: school.count
     *     2 => アカウント課金: school.mainUser[0].count.credit
     */
    schoolCredit() {
      const billingType = this.school.billing_type?.billing_type;
      let credit = 0;
      if (billingType === 1) credit = this.school.count;
      else if (billingType === 2 && this.school.mainUser[0].count) credit = this.school.mainUser[0].count.credit;
      return credit;
    },
    /**
     * 学校のテキスト利用可能回数
     */
    schoolTextCredit() {
      const billingType = this.school.billing_type?.billing_type;
      let credit = 0;
      if (billingType === 1) credit = this.school.textCount;
      return credit;
    },
    /**
     * 該当csvの本登録送信失敗件数
     */
    countFailedActivate() {
      let result = 0;
      if (!this.selectedFilename) return 0;
      const csvUserTotal = this.selectedFilename.users.length;
      console.log(csvUserTotal);
      const failedUsers = this.selectedFilename.users.filter((u) => !u.sendActivateMail);
      console.log(failedUsers.length);
      if (csvUserTotal !== failedUsers.length) {
        // 全件未送信の場合は失敗ではないため除外
        result = failedUsers.length;
        // 全件送信済みの場合はfalseを返して送信ボタンをdisabled
        if (failedUsers.length === 0) result = false;
      }
      console.log(result);
      return result;
    },
    // 検索した条件に該当する利用者のみを絞りこみ
    filteredUsers() {
      const targetIds = this.creditTargets.map((item) => item.id);
      return this.users.filter((user) => !targetIds.includes(user.id));
    },
  },
  methods: {
    /** ログインステータスのラベル文言（loginStatus → 表示文字列） */
    loginStatusLabel(status) {
      return ({
        available: 'ログイン可能',
        pending: '本人によるパスワード設定待ち',
        expired: 'リンク期限切れ・要再送',
        not_sent: 'リンク未送信',
      })[status] || '';
    },
    /** ログインステータスの詳細説明（ツールチップ表示用） */
    loginStatusDetail(status) {
      return ({
        available: 'パスワード設定済みで、本人がログインできる状態です。',
        pending: 'ログイン有効化リンクを送信済みです。本人がパスワードを設定するとログイン可能になります。',
        expired: '送信したログイン有効化リンクの有効期限が切れています。リンクを再送してください。',
        not_sent: 'ログイン有効化リンクが未送信です。リンクを送信すると本人がパスワードを設定できます。',
      })[status] || '';
    },
    judgeDisplay(args) {
      let result = true;
      if (args.cycle) {
        if (this.contents[0].value === 2) result = false;
      }
      return result;
    },
    /** contents 行をメインループで表示するか。template の v-show と groupVisibleMembers の
     *  両方がこの述語だけを見る（表示ゲートと罫線ゲートの判定式を二重化しない）。
     *  学校タイプは「学校」区分のみ選択させる（インターン/企業は school_type=6 固定・非表示）。
     *  契約プランはブロックA（学校タイプ直下）で描画するためメインループでは出さない。 */
    isRowVisible(row) {
      if (row.name === 'billing_type') return false;
      if (row.name === 'school_type' && this.is_company) return false;
      return true;
    },
    /** 行が属するグループ定義（無所属なら undefined） */
    rowGroupOf(rowName) {
      return FIELD_GROUPS.find((group) => group.members.includes(rowName));
    },
    /** 行に当てる罫線・余白クラス。グループ内の可視位置（先頭/中間/最終/単独）で切り替える。
     *  可視 member が 1 つだけに縮退したときは従来の単独行（.row）に戻す。
     *  indented 指定の行にはインデント用クラスを併せて返す。 */
    rowGroupClass(rowName) {
      const group = this.rowGroupOf(rowName);
      if (!group) return this.$style.row;
      const visible = this.groupVisibleMembers[group.name];
      const index = visible.indexOf(rowName);
      let base = this.$style.row_grouped;
      if (index < 0 || visible.length === 1) base = this.$style.row;
      else if (index === 0) base = this.$style.row_group_head;
      else if (index === visible.length - 1) base = this.$style.row_group_last;
      if ((group.indented || []).includes(rowName)) return [base, this.$style.row_indent];
      return base;
    },
    /** 行ラベルのクラス。グループの子行は住所ブロックに合わせて 1 段小さく出す */
    rowLabelClass(rowName) {
      const group = this.rowGroupOf(rowName);
      if (!group || group.promoted === rowName) return this.$style.label;
      return this.$style.sub_label;
    },
    dragover(e) {
      e.preventDefault();
    },
    optionYear(n) {
      const year = Number(this.formatTimestamp(new Date(), 'YYYY')) + 2 - n;
      return year;
    },
    /** csvファイル追加時 */
    updateFile(e) {
      let file;

      if (e.type === 'change') {
        file = e.target.files[0];
      } else if (e.type === 'drop') {
        file = e.dataTransfer.files[0];
      }

      if (!file) {
        // ファイル選択時に「キャンセル」を選択
        this.usersFile = null;
        return;
      }

      if (file.type === 'text/csv') {
        this.usersFile = file;
        this.planeFileName = file.name;
      } else {
        alert('ファイル形式が正しくありません、.csv形式のファイルを選択してください。');
        return;
      }


      // 所属タイプが学校の時はファイル名に学年必須
      if (!this.school.is_company && !this.usersFile.name.match(/_\d\./)) {
        alert('ファイル名が正しくありません。\n所属タイプが学校であればファイル名に学年を追加してください。\n（例）~school_1.csv');
        this.deleteSchoolList();
        return false;
      }

      // 所属組織が学校であれば学年をファイル名から取得し利用者に登録
      if (!this.school.is_company) this.schoolYear = this.usersFile.name.match(/_\d\./)[0].replace('_', '').replace('.', '');
      const reader = new FileReader();
      reader.readAsText(this.usersFile);
      reader.onload = this.createList;
    },
    /** CSVファイルからユーザー一覧の配列を作成 */
    createList(e) {
      const usersFileText = e.target.result;
      this.defectColumn = [];

      if (usersFileText.includes('�')) { // 文字コードがshift-jisで文字化けを起こしていたときの再エンコード
        const reader = new FileReader();
        reader.readAsText(this.usersFile, 'shift-jis');
        reader.onload = this.createList;
        return; // 文字化けテキストで後続処理を実行しないようにする
      }

      const userList = [];
      const invalidKanaRows = []; // カナ不正の行番号を収集
      const usersFileList = usersFileText.split(/\r\n|\r|\n/); // csvファイルから配列を作成

      usersFileList.forEach((user, i) => {
        if (i !== 0) { // ヘッダ行は除外
          const singleData = user.split(',');
          const emptyEelem = singleData.filter((elem) => elem === ''); // 名前、カナ、メールアドレスの項目が一つでもなかったらその行は登録スルー

          if (emptyEelem.length) {
            if (singleData.length >= 2) { // データに欠損のある行、完全な空行ではなく何らかの項目は入力のある行
              this.defectColumn.push(i + 1); // あとで登録スキップした行数をアラートで表示するのでここで記録
            }
          } else if (singleData.length > 3) { // 名前、カナ、emeil以外の余計なデータがあった際にもスルー
            this.defectColumn.push(i + 1);
          } else { // データ漏れのない行のみ仮登録へ進める
            const isValidEmail = cf.methods.isValidEmail(singleData[2]);
            if (!isValidEmail) {
              // メールアドレスが不正
              this.defectColumn.push(i + 1);
            } else {
              // カナを正規化
              const normalized = normalizeKana(singleData[1]);
              // 正規化結果が null（全角スペースのみ等）も CSV では不正扱いとする
              if (!normalized || !isValidKana(normalized)) {
                // 正規化後もカタカナ以外が残る → エラー行として記録
                invalidKanaRows.push(i + 1);
              } else {
                singleData[1] = normalized; // 正規化後の値で上書き
                userList.push(singleData);
              }
            }
          }
        }
      });

      // カナ不正行が1行でもあればファイル全体をブロック
      // ※defectColumn（欠損・メール不正）はスキップ方式だが、カナ不正は全体ブロックとする。
      //   理由: 部分登録後にCSV修正→再インポートすると、メールアドレスなしの行は
      //   重複チェックが効かず多重登録されるリスクがあるため。
      if (invalidKanaRows.length) {
        let mes = 'フリガナに全角カタカナ以外の文字が含まれている行があるため、登録を中止しました。\n'
          + 'CSVファイルのフリガナを全角カタカナに修正し、再度アップロードしてください。\n\n'
          + '対象行:\n';
        invalidKanaRows.forEach((row) => {
          mes += `${row}行目\n`;
        });
        alert(mes);
        this.deleteSchoolList(); // ファイル選択状態をリセット
        return;
      }

      this.usersFile = userList;
    },

    /** csvよりインポートされたユーザーリストを登録 */
    async registSchoolList() {
      // ↓登録の際にはデータ欠落のない人数＋登録をスキップする人数を表示
      const flag = confirm(`${this.planeFileName}に登録の${this.usersFile.length + this.defectColumn.length}人の利用者を登録します\nよろしいですか？`);
      if (!flag) {
        this.deleteSchoolList();
        return true;
      }
      const data = {
        userList: this.usersFile.reverse(), // フロントでは登録日時順に利用者をソートしているのでファイル逆順に登録してファイルと同じ並び順で見えるようにする
        // 連関テーブル(organizationData)
        organizationData: {
          organization_type: 1, // 利用者は学校に紐づくので
          foreign_id: this.school.id,
        },
      };

      let importResult;

      // importsを登録
      try {
        const params = {
          user_id: this.user.id,
          school_id: this.school.id,
          name: this.planeFileName,
          target_count: this.usersFile.length, // ImportRemindsで使用
        };

        await this.axios({
          method: 'POST',
          url: '/v1/import/set/register',
          params,
        })
          .then((response) => {
            const res = response.data;
            importResult = res;
          })
          .catch((error) => {
            if (error.message) console.log(error.message);
            else console.log(error);
          });
      } catch (error) {
        alert('CSVファイルの登録に失敗しました');
        return true;
      }

      // 所属組織が学校であれば登録情報に学年を追加
      if (!this.school.is_company) data.schoolYear = Number(this.schoolYear);

      this.showLoading();

      data.import_id = importResult.ImportModel.id; // usersテーブルとimportファイルの紐付け

      this.axios({
        method: 'POST',
        url: '/v1/user/set/temporaryRegist',
        data,
      })
        .then((response) => {
          let mes = '選択したcsvファイルに記載された利用者のインポートが完了しました';
          const result = response.data;
          if (result.registUsers.length) { // 登録完了
            mes += `\n新規仮登録者数: ${result.registUsers.length}名`;
          } else {
            mes += '\n新たに追加された利用者様はいませんでした';
          }
          if (this.defectColumn.length) {
            mes += '\n\n以下行目のデータには不備があったため登録をスキップしました。\n必須情報の欠如・メールアドレス不備・不要な列などがないかご確認ください。\n';

            this.defectColumn.forEach((elem) => {
              mes += `\n${elem}行目`;
            });
          }
          if (result.existsUsers.length) { // 登録済み
            mes += '\n\n※以下利用者様は登録済みです';
            result.existsUsers.forEach((u) => { mes += `\n${u.username}さん`; });
          }
          alert(mes);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          // 422（バリデーションエラー）のみサーバーメッセージを優先表示する。
          // 500 等のサーバー内部エラーでは英語の生メッセージをそのまま見せたくないため、
          // 従来の日本語文言にフォールバックする。
          const resData = error.response && error.response.data;
          const isValidationError = error.response && error.response.status === 422;
          let mes = (isValidationError && resData && resData.message) || 'csvファイルのユーザー登録に失敗しました';
          if (isValidationError && resData && resData.invalidKanaRows && resData.invalidKanaRows.length) {
            mes += '\n\n対象行:';
            resData.invalidKanaRows.forEach((row) => { mes += `\n${row}行目`; });
          }
          alert(mes);
        })
        .finally(() => {
          // 登録、または失敗どちらでも選択されたファイルを初期化する
          this.deleteSchoolList();
          this.hideLoading();
          // 仮登録者数の更新
          this.countUsers();
          // インポートファイルの更新
          this.getImportFiles(this.school.id);
        });
    },

    // 子コンポーネントから受け取ったデータを格納
    wordReceiveValue(data) {
      const userIdRegex = new RegExp(/^[0-9０-９]{4}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{1,}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{4}$/);
      if (userIdRegex.test(data.value)) {
        const userId = data.value.split(/[-|ー|−|―|‐|-|ｰ]/);
        this.keyword = String(Number(this.toHalfNumber(userId[2]))); // user.id指定
        this.targetColumn = ['id', 'old_id', 'tel']; // 0120-12-3456のtelも引っかかる
      } else {
        this.keyword = data.value;
        this.targetColumn = ['username', 'kana', 'id'];
      }
    },

    // アカウント利用者ごとに
    async getUsers() {
      let newUsers = [];
      const params = {
        id: this.school.id,
        targetColumn: this.keyword && this.keyword !== '' ? this.targetColumn : null,
        keyword: this.keyword && this.keyword !== '' ? this.keyword : null,
        school_year: this.schoolYear,
        noTemporary: true,
      };
      await this.axios({
        method: 'GET',
        url: '/v1/school/get/subject',
        params,
      })
        .then((response) => {
          const res = response.data.subject;
          newUsers = res.users.filter((user) => user.account_type < 11);
          this.users = newUsers;
          if (this.flag.initial && res.billing_type?.billing_type === 2) {
            this.allUsers = res.users.filter((user) => user.account_type < 11);
            this.countTemporaryUser(); // 組織の契約が従量課金であれば仮登録の利用者をカウント
            this.flag.initial = false;
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          // 検索をかけた時に、this.usersから値がなくなってしまうと、this.creditTargetsにも保持できないために追加
          const creditTargetIds = this.creditTargets.map((item) => item.id);
          const newUserIds = newUsers.map((user) => user.id);
          const idsToAdd = creditTargetIds.filter((id) => !newUserIds.includes(id));
          const usersToAdd = this.creditTargets.filter((user) => idsToAdd.includes(user.id));
          newUsers = [...newUsers, ...usersToAdd];
          this.users = newUsers;
          if (newUsers.some((user) => user.billing_type && user.billing_type.billing_type === 2)) {
            this.countTemporaryUser(); // 組織の契約が従量課金であれば仮登録の利用者をカウント
          }
          this.flag.loader = false;
          this.flag.exeSearch = true;
          this.updateTargets();
        });
    },

    /** アカウント課金のみ */
    countTemporaryUser() {
      this.allUsers.forEach((user) => {
        if (user.temporary) this.registSituation.temporary.push(user);
        else this.registSituation.completion.push(user);
      });
      this.flag.countTemporaries = false;
    },

    /**
     * アカウント課金　利用者ごとにクレジット追加時に
     */
    updateTargets() {
      // 配列を想定して書き換え
      const disabled = !this.creditTargetIds.length || !this.creditTargetIds.every((id) => typeof id === 'number');
      if (!disabled) {
        this.creditTargets = this.users.filter((user) => this.creditTargetIds.includes(user.id));
      } else {
        this.creditTargets = [];
      }
    },

    // アカウント課金、利用可能回数更新後の回数取得用
    async regetTargets() {
      const params = { // チェックのついている利用者の情報を取得
        ids: [],
      };

      this.creditTargetIds.forEach((id) => {
        params.ids.push(id);
      });

      this.axios({
        method: 'GET',
        url: '/v1/user/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.users.data;
          this.creditTargets = [];
          res.forEach((user) => {
            this.creditTargets.push(user);
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    deleteSchoolList() {
      this.planeFileName = null;
      this.usersFile = null;
      this.userList = [];
      const file = document.getElementById('file');
      file.value = '';
    },

    //** 仮登録ユーザー数を取得 */
    async countUsers() {
      this.showLoading();

      try {
        // 仮登録ユーザ
        const unregist = await this.axios({
          method: 'GET',
          url: '/v1/user/get/search',
          params: {
            school_id: this.school.id,
            temporaryOnly: 1,
            accountTypes: [1, 2, 3],
            isSchool: 0,
          },
        });
        const users = unregist.data.users;
        this.unregistUsers = users.data;
        this.userCounts.unregist = users.data.length;
        // this.generateCsv();
      } catch (error) {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      }

      try {
        // 登録済ユーザ
        const registed = await this.axios({
          method: 'GET',
          url: '/v1/user/get/search',
          params: {
            school_id: this.school.id,
            noTemporary: 1,
            accountTypes: [1, 2, 3],
            isSchool: 0,
          },
        });
        const users = registed.data.users;
        this.userCounts.registed = users.data.length;
      } catch (error) {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      }

      this.hideLoading();
    },

    /** 本登録お願いメール配信 */
    activate(users = null) {
      this.showLoading();
      if (users && users.length) {
        this.sendRemindMail(users);
      } else {
        alert('選択したcsvファイルから登録された利用者は存在しませんでした');
        this.hideLoading();
      }
    },

    /** リマインドメール配信 */
    // 引数usersは渡ってきた状態ではまだ仮登録、フラグの判定はされておらず、sendRemindMailの中で判定される
    unregistCheck(users = null) {
      this.showLoading();

      // 引数で利用者リストが渡ってきたらリストの利用者のみにリマインド送信
      if (users && users.length) {
        this.sendRemindMail(users, true);
      } else {
        alert('選択したcsvファイルには、仮登録の利用者は存在しませんでした');
        this.hideLoading();
      }

      if (this.unregistUsers.length && !users) {
        this.sendRemindMail(this.unregistUsers, true);
      } else if (!users) {
        alert(`${this.school.name}には仮登録中の利用者が存在しません`);
        this.hideLoading();
      }
    },

    /**
     * 本登録リマインドメールを仮登録ユーザーに送信
     * @params
     *   users:   obj
     *   remind: bool
     */
    sendRemindMail(users, remind) {
      const data = {
        customerList: [],
        school_id: this.school.id,
        isRemind: remind || false,
        import_id: this.selectedFilename.id, // リマインドの送信失敗に必要
      };

      // 対象利用者の抽出（flag === 1[有効]の条件を追加）
      if (remind) data.customerList = users.filter((user) => user.temporary === 1 && user.flag === 1);
      else data.customerList = users.filter((user) => !user.sendActivateMail);

      if (!data.customerList.length) {
        alert('送信対象の利用者さまが見つかりませんでした。');
        this.hideLoading();
        return;
      }

      if (remind) {
        // flag === 1[有効]の条件を追加
        const tempUsers = users.filter((user) => user.temporary === 1 && user.flag === 1);
        const registUsers = users.filter((user) => user.temporary === 0);
        const mes = `本登録: ${registUsers.length}\n仮登録: ${tempUsers.length}\n\n仮登録の利用者さま${tempUsers.length}名へリマインドメールを送信します。よろしいですか？\n`;
        const conf = confirm(mes);
        if (!conf) {
          this.hideLoading();
          return;
        }
      } else {
        const conf = confirm(`選択したcsvファイルの対象利用者さま（本登録お願いメール未送信: ${data.customerList.length}名）へ「本登録お願い」のメールを配信します。よろしいですか？`);
        if (!conf) {
          this.hideLoading();
          return;
        }
      }

      alert('csvファイルへの記載人数によってはメールの送信に時間がかかる場合があります。\nしばらくお待ちください。');

      this.axios({
        method: 'POST',
        url: '/v1/contact/officialRegist/user',
        data,
      })
        .then((response) => {
          const res = response.data;
          console.log(res);
          const mes = `メールの配信が完了しました\n送信成功: ${res.counts.success}\n送信失敗: ${res.counts.failed}`;
          alert(mes);
          // ユーザー数更新
          this.getImportFiles(this.school.id);
          this.countUsers();
          // リマインドメール送信数・日時記録
          if (remind) this.saveImportReminds();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.hideLoading();
          this.selectedFilename = 0;
        });
    },

    /** csvダウンロードデータを生成 */
    generateCsv() {
      this.flag.isNoneTemporaries = false;
      let csvData = '名前, カナ, メールアドレス\n';
      // temporaryが1でかつフラグが1のものをDLするよう変更。元々はtemporaryが1のもの全てをDLしていたが、非アクティブも含まれていた。
      const unregistUserList = this.selectedFilename.users.filter((user) => user.temporary === 1 && user.flag === 1).reverse(); // 登録時のCSVファイルと並び順揃えるため逆順

      if (!unregistUserList.length) {
        // 仮登録者がいない場合
        this.flag.isNoneTemporaries = true;
        return;
      }

      unregistUserList.forEach((user) => {
        csvData += `${user.username},`;
        csvData += `${user.kana},`;
        csvData += `${user.email || '無し'}\n`;
      });

      const now = moment().format('YYYY-MM-DD');
      this.fileName = `${now}_unregistered.csv`;
      const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]); // 文字化け対策
      const rowData = new Blob([BOM, csvData], { type: 'text/csv' });
      this.downloadUrl = (window.URL || window.webkitURL).createObjectURL(rowData);
    },

    /** CSVごとのリマインドメール送信数、日時を保存 */
    async saveImportReminds() {
      if (!this.selectedFilename) return true;
      const tempNum = this.selectedFilename.users.filter((user) => user.temporary === 1).length;
      const params = {
        import_id: this.selectedFilename.id,
        user_id: this.user.id,
        target_count: tempNum,
      };
      this.axios({
        method: 'POST',
        url: '/v1/importReminds/set/register',
        params,
      })
        .then((response) => {
          const res = response.data;
          console.log(res);
          this.getImportFiles(this.school.id);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    fromatDay(day) {
      return moment(day).format('YYYY年MM月DD日 HH時mm分');
    },

    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },
    /** カナ入力時にrow.valueへ同期しつつバリデーションチェック。
     *  refName は vuelidate ref 名（'kana' = 法人名カナ = schools.corporate_kana /
     *  'siteKana' = サイト表示名カナ = schools.kana）で invalids のキーと共通。 */
    onKanaInput(row, refName, model, invalid) {
      row.value = model;
      this.invalidsCheck(refName, invalid);
    },
    /** 法人名カナ / サイト表示名カナ: IME 確定後・blur 時に normalize（入力アシスト） */
    onKanaCompositionEnd(refName, row) {
      const normalized = normalizeKana(this[refName]);
      this[refName] = normalized;
      row.value = normalized;
      this.invalids[refName] = !!normalized && !isValidKana(normalized);
    },
    /** 主/副管理者 kana: IME 確定後・blur 時に normalize（入力アシスト） */
    onUserKanaBlur(name) {
      const values = this[`${name}Values`];
      const normalized = normalizeKana(values.kana);
      values.kana = normalized;
      this[`${name}KanaInvalid`] = !!normalized && !isValidKana(normalized);
    },
    /** 契約担当者 kana の正規化（入力アシスト。blur 時にひらがな→全角カタカナ等へ変換） */
    normalizeContractPersonKana() {
      this.contractPerson.kana = normalizeKana(this.contractPerson.kana);
    },

    /** 子から値を受け取る */
    receiveValue(values) {
      this.flag.readySubmit = values.readySubmit;
      this.address = values.address;
    },
    /** 契約担当者住所（Address の 2 インスタンス目）から値を受け取る。
     *  組織住所とは別のフラグ・別の格納先に載せる（送信先も addresses ではなく contractPersons）。 */
    receiveContractPersonValue(values) {
      this.flag.readySubmitContractPerson = values.readySubmit;
      this.contractPersonAddress = values.address;
    },
    /** 契約担当者住所の既存値を Address インスタンスへ流し込む。
     *  組織住所（setSchoolData の setCustomerData(this.school.address)）と同じ形で、
     *  API レスポンスのオブジェクトをそのまま渡す。contractPersons の住所 5 列は addresses と
     *  同名にしてあるので変換は不要。
     *  ここで this.contractPersonAddress（送信用バッファ）を渡してはいけない — 子の created() が
     *  空の初期 sendValue() を emit してバッファを空で上書きするため、既存値が復元されなくなる。
     *  この Address は v-for の外に置いているので $refs は配列にならない（組織住所側は配列）。
     *  「管理者と同一」ON では未マウントなので ref が無く、その場合は何もしない。 */
    applyContractPersonAddress() {
      const cpAddressRef = this.$refs.cpAddress;
      if (!cpAddressRef) return;
      cpAddressRef.setCustomerData((this.school && this.school.contractPerson) || {});
    },

    updateBillingTypeValue(e) {
      this.billing_type = e.target.id;
      // 課金モデルを変更したら学校タイプを初期（小学校）化する。ただし is_company（インターン/企業）は
      // school_type=6 固定かつ UI 非表示のため、リセットするとフォームから復旧できず school_type を
      // 無言で 6→1 に破壊してしまう（#3247 deep-review Critical）。学校区分のときのみ初期化する。
      if (!this.is_company) this.contents[1].value = 1;
      // billing_type 未設定（孤児校）でも空オブジェクトを生成してから代入しクラッシュを防ぐ（#3233）
      if (!this.school.billing_type) this.school.billing_type = {};
      if (this.billing_type === 'account') {
        this.flag.csvForm = true;
        this.school.billing_type.billing_type = 2;
      } else {
        this.flag.csvForm = false;
        this.school.billing_type.billing_type = 1;
      }
    },

    // オンライン利用可能回数をファイルに紐づく利用者全員に割り振るため、ファイル内の利用者全員を取得
    updateCreditTargets() {
      this.flag.exeSearch = false;
      this.creditTargets = this.creditTargetFile.users;
    },

    getSchool() {
      const params = {
        id: this.schoolId,
        includeDeleted: 1,
        isUsers: 1, // 事務局より一斉付与の際に学校に紐ずく利用者の情報が必要
      };
      this.axios({
        method: 'GET',
        url: '/v1/school/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.school = res.detail;
          // 契約担当者の初期表示：ON/OFF は schools.contract_same_as_admin から復元する
          // （列未到達の undefined も既定 ON 扱い）。入力欄の初期値は contractPerson 行があれば
          // フラグに関係なく行の実値を写す。
          // ※ ON で保存すると backend が contractPersons 行を削除する仕様なので、
          //   「フラグ ON かつ行あり」は旧仕様で残った状態（状態一覧 #2）だけが持つ。
          //   その残存値を OFF に戻したときに表示できるよう、ここではフラグを見ずに写している。
          const cp = this.school.contractPerson;
          this.contractPerson = {
            sameAsAdmin: Number(this.school.contract_same_as_admin) !== 0,
            name: (cp && cp.name) || '',
            kana: (cp && cp.kana) || '',
            department: (cp && cp.department) || '',
            position: (cp && cp.position) || '',
            email: (cp && cp.email) || '',
            tel: (cp && cp.tel) || '',
          };
          // 住所は Address コンポーネントが自前の state で保持するため、入力欄がマウントされた時点で
          // school.contractPerson から直接流し込む（applyContractPersonAddress）。
          // 上の sameAsAdmin 代入が watcher を発火させ、そこで prefill が走る。
          if (this.school.billing_type?.billing_type === 2) {
            this.flag.csvForm = true; // csvファイル登録フォーム表示フラグを更新
            this.measuredDatas.pop();
            this.getImportFiles(this.school.id);
            // 各登録数を使用するのはアカウント課金のみ
            this.countUsers();
          }
          if (this.school.contract && this.school.contract.cycle && this.measuredDatas && this.measuredDatas[2]) {
            this.measuredDatas[2].value = this.school.contract.cycle;
          }
          this.setSchoolData();
          this.getContract();
          this.getSchoolMemo();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    // 学校ごとにインポートしたCSVファイルを取得（アカウント課金のみ）
    getImportFiles(schoolId) {
      this.axios({
        method: 'GET',
        url: '/v1/import/get/list',
        params: { school_id: schoolId },
      })
        .then((response) => {
          const res = response.data;
          this.importFiles = res.imports.data;
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    getContract() {
      this.axios({
        method: 'GET',
        url: '/v1/contract/get/detail',
        params: { school_id: this.schoolId },
      })
        .then((response) => {
          this.measuredDatas.forEach((elem) => {
            if (elem.name === 'contractName') {
              elem.value = response.data.contract.name;
            } else if (elem.name === 'contractDate') {
              const date = response.data.contract.contract_date;
              elem.values.year = moment(date).format('YYYY');
              elem.values.month = Number(moment(date).format('MM'));
              elem.values.day = Number(moment(date).format('DD'));
            } else if (elem.name === 'cycle') {
              elem.value = response.data.contract.cycle;
            } else if (elem.name === 'textDefaultCount') {
              elem.value = response.data.contract.base_text;
            }
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    async getSchoolMemo() {
      const params = { school_id: this.schoolId };

      this.axios({
        method: 'GET',
        url: '/v1/schoolMemo/get/detail',
        params,
      })
        .then((response) => {
          if (response.data.detail.data.length) {
            const res = response.data.detail.data[0];
            this.schoolMemo = res.memo;
            this.features = res.features;
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    setSchoolData() {
      this.is_company = this.school.is_company;
      // 組織区分は read-only 表示のみ（更新では送信しない）。既存値を読み取り反映する。
      this.is_corporate = this.school.is_corporate;
      // 既存値から単一「組織タイプ」3区分（read-only 表示）を導出（corporateSchool mixin に集約）。
      this.orgType = this.orgTypeOf(this.school);
      this.savedBillingType = this.school.billing_type ? this.school.billing_type.billing_type : null;
      this.contents.forEach((row) => {
        if (row.name === 'billing_type' || row.name === 'course') {
          // billing_type 未設定（孤児校）は index 参照をスキップ（#3233）
          if (this.school.billing_type) row.value = this.school.billing_type[row.name];
        } else {
          row.value = this.school[row.name];
        }
      });
      // カナ 2 種は vuelidate ref（$v 経由で入力欄に束縛）にも写す。row.value だけ入れても
      // 入力欄は ref を見るため、写さないと DB に値があるのに欄が空表示になる。
      this.kana = this.school.corporate_kana || '';
      this.siteKana = this.school.kana || '';
      // Address は v-for（contents 行）の内側で描画するため、$refs.address は配列で返る（Vue 3 の仕様）
      const addressRef = Array.isArray(this.$refs.address) ? this.$refs.address[0] : this.$refs.address;
      if (this.school.address && addressRef) addressRef.setCustomerData(this.school.address);
      this.flag.loader = false;

      if (this.school.billing_type && this.school.billing_type.billing_type === 2) {
        this.billing_type = 'account';
      } else {
        this.billing_type = 'default';
      }
    },

    setSchoolYear() {
      if (this.user.school) {
        const school = this.school;
        const yearIndex = Object.keys(this.helper.master.schoolYear).findIndex((elem) => this.helper.master.schoolYear[elem].label === school.school_type);
        const schoolYear = this.helper.master.schoolYear[yearIndex]
          ? this.helper.master.schoolYear[yearIndex].value
          : -2;
        return schoolYear + 2;
      }
    },

    /** 必須項目の入力をチェック */
    changeFlag() {
      let filledRequired = true;
      this.contents.forEach((row) => {
        if (row.required) {
          if (!this.isRowVisible(row)) {
            // 画面に出ていない行（契約プラン／インターン・企業の学校タイプ）は必須対象外。
            // 必須判定の発火条件を入力 UI の表示ゲート（isRowVisible）と同一にする＝軸一致。
          } else if (
            row.name === 'address'
            || row.name === 'emailUser'
            || row.name === 'school_type'
          ) {
            // 学校タイプは radio で常に値を持ち「個人向け(0)」が正当な値なので空チェックの対象外。
            // 住所は Address の readySubmit、管理者メールは invalids.mailUser で個別に見る。
            // （ここで filledRequired を true に再代入すると、それ以前の行の未入力が握り潰される）
          } else if (row.value === null || row.value === '' || row.value === 0) {
            filledRequired = false;
          }
        }
      });

      // 新設・移設した項目は名指しの alert を先に出す（汎用の「必須項目が未入力です」だけだと
      // どの欄を直せばよいか分からないため）。文言は画面の表示ラベルと同語にする。
      // サイト表示名カナ（kana）の row.label は見出し（サイト表示名）と重ねて読む前提の「カナ」なので、
      // 単独で出す alert では欄を特定できる語に置き換える。
      const namedRequiredRows = [
        { name: 'name', label: 'サイト表示名' },
        { name: 'kana', label: 'サイト表示名カナ' },
        { name: 'corporate_name', label: '法人名' },
        { name: 'corporate_kana', label: '法人名カナ' },
      ];
      for (let i = 0; i < namedRequiredRows.length; i += 1) {
        const row = this.contents.find((r) => r.name === namedRequiredRows[i].name);
        if (row && row.required && (row.value === null || row.value === '')) {
          alert(`${namedRequiredRows[i].label}を入力してください`);
          return;
        }
      }

      if (this.contents[0].value === 1) { // 従量課金の時は契約内容の入力を必須化
        this.measuredDatas.forEach((elem) => {
          if (elem.required) {
            if (elem.name === 'contractDate') {
              Object.keys(elem.values).forEach((data) => {
                if (!elem.values[data]) filledRequired = false;
              });
            } else if (!elem.value) filledRequired = false;
          }
        });
      }

      if (!filledRequired) {
        alert('必須項目が未入力です');
        return;
      }
      if (!this.flag.readySubmit) {
        alert('住所の項目に不備があります。');
        return;
      }
      if (this.invalids.siteKana) {
        alert('サイト表示名カナはカナ文字のみで入力してください。');
        return;
      }
      if (this.invalids.kana) {
        alert('法人名カナはカナ文字のみで入力してください。');
        return;
      }
      // 契約担当者（「管理者と同一」OFF 時のみ）。氏名/カナ必須・カナ形式検証は主管理者と同型（純粋関数判定）。
      // 部署/職階は入力欄と同じ contractPersonFieldDefs を走査して必須判定する（表示と判定の軸一致）。
      // ON のときは入力欄が非表示なので一切チェックしない。
      if (!this.contractPerson.sameAsAdmin) {
        if (!this.contractPerson.name) {
          alert('契約担当者の氏名を入力してください');
          return;
        }
        const cpKana = normalizeKana(this.contractPerson.kana);
        this.contractPerson.kana = cpKana;
        if (!cpKana) {
          alert('契約担当者のカナを入力してください');
          return;
        }
        if (!isValidKana(cpKana)) {
          alert('契約担当者のカナはカナ文字のみで入力してください。');
          return;
        }
        // alert の語は defs の label をそのまま使う＝画面の入力欄ラベルと必ず同語になる
        // （master ラベル(所属等)だと画面に出ていない語でエラーになり操作者が対応先を見失う）
        const cpMissingField = this.contractPersonFieldDefs()
          .find((f) => !this.contractPerson[f.name]);
        if (cpMissingField) {
          alert(`契約担当者の${cpMissingField.label}を入力してください`);
          return;
        }
        // 未入力の指摘順は入力欄の表示順（電話番号 → メールアドレス）に揃える
        // （上から埋める操作者に対して、最初に止まる欄が画面の最上位の空欄になるようにする）
        if (!this.contractPerson.tel) {
          alert('契約担当者の電話番号を入力してください');
          return;
        }
        if (!this.contractPerson.email) {
          alert('契約担当者のメールアドレスを入力してください');
          return;
        }
        // 主管理者は vuelidate (mailUser.email) で形式チェックする。契約担当者は v-if 内でマウント・
        // アンマウントされる欄なので、純粋関数（commonFunctions の isValidEmail）で判定する
        // ([[feedback_vuelidate_avoid_array_validation]] と同じ理由)。
        if (!this.isValidEmail(this.contractPerson.email)) {
          alert('契約担当者のメールアドレスの形式が正しくありません');
          return;
        }
        // 住所は Address コンポーネント側の検証結果（郵便番号/都道府県/市区町村/番地）で判定する
        if (!this.flag.readySubmitContractPerson) {
          alert('契約担当者の住所の項目に不備があります。');
          return;
        }
      }

      this.flag.isConfirm = !this.flag.isConfirm;
      if (this.flag.isConfirm) {
        const elem = document.getElementById('confirm');
        const position = elem.getBoundingClientRect().top;
        scrollBy(0, position - 77);
      }
    },

    /** 登録 */
    update() {
      this.showLoading();
      const data = {};
      this.contents.forEach((row) => {
        if (row.name !== 'billing_type' && row.name !== 'course') {
          data[row.name] = row.value;
        }
      });
      // 組織のメールアドレス（schools.email）は入力欄ごと撤去したため送らない。
      // School.update() は fill→save の dirty 列のみ UPDATE するので既存値は保持される（列とデータは残置）。
      data.id = this.schoolId;
      // 組織区分(is_company/is_corporate)は更新経由で変えない＝送信しない。
      // backend School.update() は fill→save の dirty 列のみ UPDATE するため、
      // payload から外せば既存値が保持される（学校⇄インターン付替え・id=18 企業昇格は DB 直対応）。

      // 「管理者と同一か」は schools 本体のフラグで保持する（数値固定で送信）。ON=1（契約担当者＝
      // 主管理者）／OFF=0（個別設定）。
      data.contract_same_as_admin = this.contractPerson.sameAsAdmin ? 1 : 0;

      // 契約担当者の実値は「管理者と同一」OFF のときだけ送る（個別設定の実値専用）。ON のときは
      // contractPersonData を送らず、backend が contract_same_as_admin=1 を受けて既存行を削除する
      // （「フラグ ON かつ行あり」= 状態一覧 #2 を残さないための仕様。表示側は主管理者情報を代替表示）。
      if (!this.contractPerson.sameAsAdmin) {
        // 住所は addresses ではなく contractPersons の同名列へ直接載せる（Address が emit する
        // キーと列名を揃えてあるので変換不要）。
        const cpAddress = this.contractPersonAddress || {};
        data.contractPersonData = {
          name: this.contractPerson.name || null,
          kana: this.contractPerson.kana || null,
          department: this.contractPerson.department || null,
          position: this.contractPerson.position || null,
          email: this.contractPerson.email || null,
          tel: this.contractPerson.tel || null,
          zip: cpAddress.zip || null,
          pref: cpAddress.pref || null,
          city: cpAddress.city || null,
          address: cpAddress.address || null,
          building: cpAddress.building || null,
        };
      }

      this.axios({
        method: 'POST',
        url: '/v1/school/set/updater',
        data,
      })
        .then((response) => {
          this.schoolID = response.data.schoolID;
          this.updateAddress();
          this.updateBillingType();
          this.updateContract();
          if (this.flag.changeSchoolMemo) this.updateSchoolMemo();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          // バックエンドのバリデーションエラー（フリガナ等）メッセージがあれば表示
          const serverMessage = error.response && error.response.data && error.response.data.message;
          alert(serverMessage || '組織情報の更新に失敗しました。');
          this.hideLoading();
        });
    },


    updateAddress() {
      const data = this.address;
      data.id = this.school.address ? this.school.address.id : null;
      data.foreign_id = this.school.id;
      data.model_type = 2;

      const endpoint = data.id ? 'updater' : 'register';
      this.axios({
        method: 'POST',
        url: `/v1/address/set/${endpoint}`,
        data,
      })
        .then(() => {
          alert('更新が完了しました。');
          this.hideLoading();
          this.$router.push('/operator/?tab=schools');
        })
        .catch((error) => {
          console.log(error);
          alert('住所情報の更新に失敗しました。');
          this.hideLoading();
        });
    },

    updateBillingType() {
      // billing_type レコードが無い（孤児校）場合は更新 API を撃たない（#3233）
      if (!this.school.billing_type) return;
      const data = {
        id: this.school.billing_type.id,
        billing_type: this.contents[0].value,
        // course: null, // 現在はコースは登録時以外、変動させない
        school_id: this.school.id,
      };
      this.axios({
        method: 'POST',
        url: '/v1/school/billingtype/set/updater',
        data,
      })
        .then(() => {
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          alert('契約プランの登録に失敗しました。');
        });
    },

    updateContract() {
      // 契約日を '2024-4-1' のような非 ISO 文字列に組んで moment へ渡すと、ブラウザのエンジン実装依存で
      // Invalid date になる（RegistSchool.registContract は同じ理由で ISO 直組みに修正済み）。
      // 年月日が欠けていると null になる。null が届く経路は 2 つあるが、どちらも旧来の 'Invalid date' と
      // 帰結が同じ（保存されず更新失敗の alert が出る）なので、送信前のガードは置かない:
      //   ・契約レコードを持たない組織 … バックエンドが school_id 検索の時点で 404 を返し DB に触らない
      //   ・契約日の必須チェックを迂回できる組織（必須化が従量課金プランの分岐の中にあるため）
      //     … contracts.contract_date は NOT NULL なので、厳格モードならどちらの値でもエラーで書込なし、
      //       非厳格モードならどちらも 0000-00-00 に丸められる
      const contractDate = toISODateString(
        this.measuredDatas[1].values.year,
        this.measuredDatas[1].values.month,
        this.measuredDatas[1].values.day,
      );
      let expiry;
      if (this.measuredDatas[2].value === 1) {
        expiry = moment(contractDate).add(30, 'd').format('YYYY-MM-DD');
      } else {
        expiry = moment(contractDate).add(1, 'year').format('YYYY-MM-DD');
      }
      const data = {
        school_id: this.schoolID,
        name: this.measuredDatas[0].value,
        contract_date: contractDate,
        expiry,
        cycle: this.measuredDatas[2].value,
      };

      if (this.school.billing_type?.billing_type === 1) {
        data.base_text = this.measuredDatas[3].value;
        // data.base_online = this.measuredDatas[4].value;
      } else {
        data.base_text = 0;
        // data.base_online = 0;
      }

      this.axios({
        method: 'POST',
        url: '/v1/contract/set/updater',
        data,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
          alert('契約情報の更新に失敗しました');
        });
    },

    /**
     * 学校メモを更新/保存
     * すでに学校メモが登録されていれば更新なければ新規作成
     */
    async updateSchoolMemo() {
      // メモ項目がすべて未入力の場合は削除
      if (!this.schoolMemo && !this.features) {
        this._deleteSchoolMemo();
        return;
      }

      const data = {
        school_id: this.school.id,
        memo: this.schoolMemo,
        features: this.features,
      };

      this.axios({
        method: 'POST',
        url: '/v1/schoolMemo/set/updater',
        data,
      })
        .then((response) => {
          const res = response.data;
          console.log(res);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },
    _deleteSchoolMemo() {
      this.axios({
        method: 'POST',
        url: '/v1/schoolMemo/set/delete',
        data: { school_id: this.school.id },
      })
        .then((response) => {
          const res = response.data;
          console.log(res);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          alert('学校メモの削除に失敗しました。');
        });
    },

    /** 主管理者の schoolAdmins 行を取得（department/position/role 引き用） */
    getMainSchoolAdmin(userId) {
      if (!this.school || !Array.isArray(this.school.schoolAdmins)) return null;
      return this.school.schoolAdmins.find((a) => a.user_id === userId) || null;
    },
    /** 主管理者表示の各フィールドを取得（所属/職階/役割は schoolAdmins から引く） */
    getMainUserField(row, fieldName) {
      if (fieldName === 'department' || fieldName === 'position' || fieldName === 'role') {
        const matched = this.getMainSchoolAdmin(row.id);
        return matched ? matched[fieldName] : null;
      }
      return row[fieldName];
    },

    editStart(target, name) {
      this.subErrorMessage = null;
      if (name === 'sub') {
        if (!target) {
          this.editCancel('sub');
          this.flag.registSubUser = true;
          this.editingSubKey = null;
          this.subValues = {
            id: null, username: null, kana: null, email: null, department: null, position: null, role: null, _source: 'users',
          };
          return;
        }
        this.flag.registSubUser = false;
        this.editingSubKey = `${target._source}-${target.id}`;
        this.subValues = {
          id: target.id,
          username: target.username,
          kana: target.kana,
          email: target.email,
          department: target.department,
          position: target.position,
          role: target.role,
          _source: target._source,
        };
        return;
      }
      // name === 'main'
      this.flag.registSubUser = false;
      const matched = this.getMainSchoolAdmin(target.id);
      this.mainValues = {
        id: target.id,
        username: target.username,
        kana: target.kana,
        email: target.email,
        department: matched ? matched.department : null,
        position: matched ? matched.position : null,
        role: matched ? matched.role : null,
      };
    },

    editCancel(name) {
      this.subErrorMessage = null;
      this.flag.registSubUser = false;
      if (name === 'sub') {
        this.editingSubKey = null;
        this.subValues = {
          id: null, username: null, kana: null, email: null, department: null, position: null, role: null, _source: null,
        };
        return;
      }
      this.mainValues = {
        id: null, username: null, kana: null, email: null, department: null, position: null, role: null,
      };
    },

    updateUser(name) {
      this.subErrorMessage = null;
      this.showLoading();
      const values = this[`${name}Values`];
      const data = { ...values };
      const isMain = name === 'main';
      const url = isMain ? 'user' : 'user/sub';
      const endpoint = data.id ? 'update' : 'register';
      const label = data.id ? '更新' : '登録';
      if (!data.username || data.username === '') {
        alert('氏名を入力してください');
        this.hideLoading();
        return;
      }
      if (!data.kana || data.kana === '') {
        alert('カナを入力してください');
        this.hideLoading();
        return;
      }
      if (!isValidKana(data.kana)) {
        alert('カナは全角カタカナで入力してください。');
        this.hideLoading();
        return;
      }
      if (!data.email || data.email === '') {
        alert('メールアドレスを入力してください。');
        this.hideLoading();
        return;
      }
      // レガシー subUsers 由来の編集は所属/職階/役割の保存先(schoolAdmins)を持たず、移管後にのみ設定可能なため必須にしない
      // （BE 側でも subUsers 分岐で department/position/role は無視される）。
      // 必須対象はサイト種別で表示中の列（非表示列は送信直前に null 化して BE で null 保存）。
      if (data._source !== 'subUsers') {
        // 主管理者は schoolAdminFields（全列）、副管理者は schoolAdminFieldsSub（company/university は所属含む3列必須・
        // school 種別は所属を出さず職階/役割のみ必須）。所属は表示される種別では主/副とも必須。
        const requiredFields = isMain
          ? this.schoolAdminFields
          : this.schoolAdminFieldsSub;
        const missingField = requiredFields.find((field) => !data[field.name] || data[field.name] === '');
        if (missingField) {
          alert(`${missingField.label}を入力してください。`);
          this.hideLoading();
          return;
        }
      }
      if (!data.id) data.school_id = this.school.id;
      if (isMain) {
        data._source = 'users';
      }
      // 非表示の所属/職階/役割 列は null で送る（学校タイプ切替などで取り残された旧値を DB に残さない）。
      // 副管理者(12)は school 種別で所属も非表示になるため accountType を渡して null 化対象を揃える。
      this.clearHiddenSchoolAdminFields(data, this.school && this.school.is_company, this.school && this.school.school_type, isMain ? 11 : 12);

      this.axios({
        method: 'POST',
        url: `/v1/${url}/set/${endpoint}`,
        data,
      })
        .then((response) => {
          if (response.data.duplicate) {
            // 重複時はフォームを閉じず（editCancel/getSchool しない）、入力値を保持したまま
            // フォーム内にエラーを表示して、その場でメールアドレスを訂正・再送信できるようにする。
            // メッセージは BE が temporary で出し分けた仮登録/本登録文言（response.data.message）を表示する。
            this.subErrorMessage = response.data.message;
            this.hideLoading();
            return;
          }
          alert(`${label}が完了しました。`);
          this.getSchool();
          this.editCancel(name);
          this.hideLoading();
        })
        .catch((error) => {
          const status = error.response && error.response.status;
          const serverMessage = error.response && error.response.data && error.response.data.message;
          if (!isMain && (status === 409 || status === 422)) {
            this.subErrorMessage = serverMessage || `${label}に失敗しました。`;
          } else {
            alert(serverMessage || `${label}に失敗しました。`);
          }
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },

    deleteSubUser() {
      const userData = this.subValues;
      // eslint-disable-next-line no-restricted-globals, no-alert
      const ok = confirm(`${userData.username} さんを副管理者から削除します。この操作は取り消せません。よろしいですか？`);
      if (!ok) return;
      this.showLoading();
      const data = {
        id: userData.id,
        flag: 999,
        _source: userData._source,
      };
      this.axios({
        method: 'POST',
        url: '/v1/user/sub/set/update',
        data,
      })
        .then(() => {
          alert('副管理者の削除が完了しました');
          this.getSchool();
          this.editCancel('sub');
          this.hideLoading();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          alert('副管理者の削除に失敗しました。お手数ですが管理者までお知らせください');
          this.hideLoading();
        });
    },

    /** ログイン有効化リンク送信（PW 設定リンクを送信して副管理者のログインを有効化する） */
    sendPasswordSetupLink(row) {
      // eslint-disable-next-line no-restricted-globals, no-alert
      const ok = confirm(`${row.username} さんにログイン有効化リンクを送信します。よろしいですか？`);
      if (!ok) return;
      this.subErrorMessage = null;
      this.showLoading();
      this.axios({
        method: 'POST',
        url: '/v1/user/sub/set/sendPasswordSetupLink',
        data: {
          id: row.id,
          _source: row._source,
        },
      })
        .then(() => {
          alert('ログイン有効化リンクを送信しました');
          this.getSchool();
          this.hideLoading();
        })
        .catch((error) => {
          const serverMessage = error.response && error.response.data && error.response.data.message;
          // この処理はリスト行のボタンから呼ばれ編集フォームを開いていないため、
          // subErrorMessage（フォーム内表示）では表示先が無く失敗が見えなくなる。
          // 重複エラーのフォーム内表示とは別経路として、失敗は alert で通知する。
          alert(serverMessage || 'ログイン有効化リンクの送信に失敗しました。');
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },

    changeOpenBulkCountHistory() {
      this.flag.openBulkCountHistory = !this.flag.openBulkCountHistory;
      this.getBulkCountHistorys();
    },

    async getBulkCountHistorys() {
      const target = this.school;

      const params = {
        school_id: target.id,
        isImport: 1,
      };

      this.axios({
        method: 'GET',
        url: '/v1/bulkCount/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.data.data;
          this.bulkCountHistorys = [];
          res.forEach((data) => {
            const insertData = {
              date: moment(data.created_at).format('YYYY年MM月DD日'),
              counselor_type: data.counselor_type === 21 ? '医師' : '心理士',
              content: `${data.count}回${data.is_add ? '追加' : '削除'}`,
              import_file: data.import ? data.import.name : '全体',
            };
            this.bulkCountHistorys.push(insertData);
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    /**
     * 学校へのオンラインクレジットを付与
     */
    setCredit(addFlag) {
      if (!this.credit || this.credit < 0) {
        this.credit = 1;
        return alert('1以上の値を設定してください');
      }

      if (this.credit > this.schoolCredit && !addFlag) {
        return alert('削除するクレジットが保有クレジットを超えています');
      }

      const label = addFlag ? '追加' : '削除';
      const message = {
        confirm: `「${this.school.name}」へ${this.credit}オンラインクレジット${label}しますか？`,
        done: `「${this.school.name}」へ${this.credit}オンラインクレジット${label}しました`,
      };
      const confirm = window.confirm(message.confirm);
      if (!confirm) return;

      this.showLoading();

      const billingType = this.school.billing_type?.billing_type;
      // 従量課金は学校ID、アカウント課金は管理者userId
      const foreignId = billingType === 1
        ? this.school.id
        : this.school.mainUser[0].id;
      const data = {
        billing_type: billingType,
        foreign_id: foreignId,
        count: this.credit,
        is_add: addFlag, // 1:特別加算、0:通常
        credit_user_id: this.user.id,
      };

      this.axios({
        method: 'POST',
        url: '/v1/count/history/set/register',
        data,
      })
        .then(() => {
          this.getSchool();
          this.credit = null;
          if (data.billing_type === 2) { // アカウント課金タイプなら事務局→学校のクレジット編集履歴を記録
            this.registSustainableAddCredit(data); // 記録するのは付与情報なのでdataそのままでOK
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          alert(message.done);
          this.hideLoading();
        });
    },

    setTextCredit(addFlag) {
      if (!this.textCredit || this.textCredit < 0) {
        this.textCredit = 1;
        return alert('1以上の値を設定してください');
      }

      if (this.textCredit > this.schoolTextCredit && !addFlag) {
        return alert('削除するカウントがテキスト利用可能回数を超えています');
      }

      const label = addFlag ? '追加' : '削除';
      const message = {
        confirm: `「${this.school.name}」へテキスト利用可能回数を${this.textCredit}回${label}しますか？`,
        done: `「${this.school.name}」へテキスト利用可能回数を${this.textCredit}回${label}しました`,
      };
      const confirm = window.confirm(message.confirm);
      if (!confirm) return;

      this.showLoading();

      const data = {
        school_id: this.school.id,
        count: this.textCredit,
        is_add: addFlag, // 1:特別加算、0:通常
      };

      this.axios({
        method: 'POST',
        url: '/v1/count/historyText/set/register',
        data,
      })
        .then(() => {
          this.getSchool();
          this.textCredit = null;
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          alert(message.done);
          this.hideLoading();
        });
    },

    /**
     * csv選択時にリマインドメールの
     * 送信失敗数とユーザーを取得
     * 本登録お願いメールはcomputedで直接取れる
     */
    async getRemindFailedCount() {
      this.failedReminds = [];
      const params = {
        import_id: this.selectedFilename.id,
      };
      this.axios({
        method: 'GET',
        url: '/v1/remindFailed/get/list',
        params,
      })
        .then((response) => {
          const data = response.data.data.data;
          if (data.length) {
            data.forEach((row) => {
              this.failedReminds.push(row);
            });
          }
          this.generateCsv();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    /** リマインドメール再送信 */
    resendRemind() {
      const conf = confirm('表示されている利用者さまへリマインドメールの再送信を実行します。よろしいですか？');
      if (!conf) return;

      this.showLoading();

      this.axios({
        method: 'POST',
        url: '/v1/contact/remindResend/user',
        data: {
          failedReminds: this.failedReminds,
          school_id: this.school.id,
          import_id: this.selectedFilename.id,
        },
      })
        .then((response) => {
          const data = response.data;
          const mes = `メールの配信が完了しました\n送信成功: ${data.counts.success}\n送信失敗: ${data.counts.failed}`;
          alert(mes);
          // ユーザー数更新
          this.getImportFiles(this.school.id);
          this.countUsers();
          // 送信失敗件数更新
          this.getRemindFailedCount();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    /** サステナブルクレジット編集を保存 */
    registSustainableAddCredit(datas) {
      const params = {
        regist_user_id: datas.credit_user_id,
        school_id: this.school.id,
        is_add: datas.is_add,
        credit: datas.count,
      };

      this.axios({
        method: 'post',
        url: '/v1/sustainableAddCredit/set/register',
        params,
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    /** サステナブル利用可能回数更新時 */
    updateTargetCount() {
      this.creditTargetFile = null; // 更新が完了したら編集対象のセレクトボックス初期化
    },

    /** userBox背景色指定用 */
    userBoxColor(user) {
      let color;
      if (user.flag !== 1) {
        color = 'gray';
      } else if (user.temporary) {
        color = 'silver';
      } else {
        color = 'white';
      }
      return color;
    },

    /**
     * 調整履歴をクリックした際に、
     * 変更を加えた利用者一覧を表示した状態で利用者検索画面を開く
     */
    async jumpUserList(fileName) {
      const targetFile = this.importFiles.find((elem) => elem.name === fileName);

      if (targetFile) {
        const targetIds = [];
        targetFile.users.forEach((user) => {
          targetIds.push(user.id);
        });
        this.$store.state.search_targets = targetIds;
        const resolvedRoute = await this.$router.resolve({
          name: 'Operator',
        });
        resolvedRoute.href += '/?tab=users&page=1';
        console.log(this.$store.state.search_targets);
        // window.open(resolvedRoute.href, '_blank');
        window.open(resolvedRoute.href);
      } else {
        return true;
      }
    },

    changeOrganizationType() {
      // 更新画面の組織タイプは read-only（template で :disabled="true"）のため実際には発火しない。
      // 組織区分は更新経由で変更しない設計（既存値保持・変更は DB 直対応）。no-op で据え置く。
    },
  },
};
</script>

<style lang="scss" module>
.prev_right {
  display: flex;
  justify-content: right;
}
.row {
  padding: 24px 0;
  border-top: 1px solid var(--gray-main);
}
// グループ化された行（罫線 1 本の中に関連項目をまとめる）。値は住所ブロック
// （parts/Form/Address.vue の dl:not(:first-child) { margin-top: 20px }）に合わせている。
// .row 本体は他用途でも使うため変更せず、新規クラスのみで表現する。
.row_group_head {
  padding: 24px 0 0;
  border-top: 1px solid var(--gray-main);
}
.row_grouped {
  padding: 20px 0 0;
}
.row_group_last {
  padding: 20px 0 24px;
}
// 見出しの選択に従属する子行の字下げ。契約プラン配下の「パターン種別」（.contract）と同値。
// padding shorthand（padding-left: 0）を上書きするため上記の余白クラスより後方に置く。
.row_indent {
  padding-left: 1em;
}
.label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  display: inline-block;
  &_wrap {
    display: flex;
    align-items: baseline;
  }
}
// グループの子行ラベル。住所ブロックの子ラベル（font-size: 14px）と揃える
.sub_label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  display: inline-block;
  font-size: 14px;
}
.text, .select {
  &:disabled {
    color: black;
    background-color: transparent;
    &:-webkit-autofill {
      box-shadow: 0 0 0 100px white inset;
    }
  }
}
.notes {
  font-size: 12px;
  color: red;
}
.remind_history {
  span {
    font-size: .85em;
  }

  &_row {
    padding-left: 2em;
  }
  td {
    text-align: center;
  }
}
.bold {
  font-size: 13px;
  font-weight: bold;
}
.required {
  font-size: 12px;
  color: red;
}
.textarea {
  width: 100%;
  border: none;
  outline: none;
  background-color: var(--gray-sub);
  border-radius: 10px;
  resize: vertical;
  padding: 20px;
}
.assistant {
  font-size: 12px;
}
.same_as_admin {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.space {
  padding-top: 6px;
}
.text {
  width: 100%;
  padding: 13px;
  border-radius: 8px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  $background: var(--gray-sub);
  &:-webkit-autofill {
    box-shadow: 0 0 0 100px $background inset;
  }
  &_count {
    width: 20%;
    padding: 13px;
    border-radius: 8px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    $background: var(--gray-sub);
    text-align: right;
  }
}
.icon_gray {
  color: #808080;
  cursor: pointer;
}
.radio {
  padding-top: 8px;
  display: flex;

  li {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}
.select {
  padding: 13px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  border-radius: 8px;
  appearance: none;

  &_wrap {
    display: flex;

    li {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  &_box {
    width: 100px;
    padding: 13px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    border-radius: 8px;
    appearance: none;

    &_wrap {
      display: flex;

      li {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
}
.tel {
  width: 70px;
  padding: 13px;
}
.users {
  margin-top: -20px;
}
.download {
  // text-align: center;
  &BTN {
    // margin-top: 10px;
    padding: 8px 25px;
    font-weight: bold;
    font-size: 16px;
    background-color: #666;
    color: white;
    border-radius: 22px;
  }
}
.read_csv {
  display: block;
  text-align: center;
  background-color: var(--gray-sub);
  border-radius: 5px;
  position: relative;
  button {
    margin-top: 10px;
  }
  .assistance {
    position: absolute;
    top: 72%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    background-color: transparent;
    z-index: 0;
  }
}
.file_input {
  width: 100%;
  padding: 4% 35% 6%;
  background-color: transparent;
  position: relative;
  z-index: 1;
}
.file_input:hover {
  cursor: pointer;
}
.file_name {
  text-align: center;
}
.unregistered {
  font-weight: bold;
  &_large {
    font-size: 1.4em;
  }
}
.search_wrap {
  display: flex;
  .search_word {
    flex: 8.5;
  }
  .search_button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1.5;
  }
}
.check_user {
  display: flex;
  &_box {
    flex: 1;
  }
}
.user_check {
  display: flex;
  &_box {
    margin-right: 1em;
  }
  &_user_box {
    flex-grow: 1;
  }
}
.userCounts {
  dl {
    font-weight: bold;
    display: flex;
    margin: 0;
    line-height: 1.8;
    dt {
      min-width: 6.7em;
      &:after {
        content: ":";
      }
    }
    dd {
      margin-left: 0;
      min-width: 4em;
      text-align: right;
      &:after {
        content: "名";
        margin-left: .2em;
      }
      span {
        font-size: 12px;
      }
    }
    span {
      font-size: 12px;
    }
  }
}
.flex_elem {
  display: flex;
}
.user {
  &_wrap {
    margin-top: 20px;
  }
  li {
    &:not(:first-child) {
      margin-top: 12px;
    }
  }
  &_value {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    i {
      margin-right: 12px;
      color: var(--orange-main);
    }
  }
}

.count {
  display: flex;
  align-items: baseline;
}

.assistance {
  font-size: 14px;
  &.danger {
    color: red;
  }
}
.contract {
  padding-left: 1em;
  &_list {
    padding-top: 20px;
  }
}
// テキスト基本回数/契約名/契約年月日（ブロックB）用。契約プラン radio 配下のネストを外れたため
// 字下げしない（通常行とインデントを揃える）
.contract_flat {
  padding-left: 0;
  // 先頭項目は親 .row の padding(24px) と .contract_list の padding-top(20px) が重なって
  // 他の行より上余白が大きくなるため、先頭のみ打ち消して通常行と揃える
  > li:first-child {
    padding-top: 0;
  }
}
.categories {
  $mgn: 40px;
  $gry: #ccc;
  $bdr: 1px solid $gry;
  $pd: .5em;
  width: 75%;
  .category {
    font-size: .8em;
    padding: $mgn/5 0;
    border-bottom: $bdr;
    display: flex;
    margin-block-start: 0;
    margin-block-end: 0;
    // width: 90%;
    &:first-child {
      border-top: $bdr;
    }
     > dt, dd {
      padding: 0 $pd;
      margin-inline-start: 0;
    }
   > dt {
      width: 45%;
    }
    > dd {
      flex: 1;
    }
    .link {
      margin-left: auto;
      padding-left: 1em;
    }

    &.pointer {
      cursor: pointer;
    }

    .width_break {
      word-break: break-word;
    }
  }
  &.max_width {
    width: 100%;
  }
}
.birth {
  flex: 1;
  dl {
    display: flex;
    align-items: center;
    margin: 0;
  }
  dt {
    width: 7em;
    i {
      margin-right: .5em;
    }
  }
  dd {
    flex: 1;
    display: flex;
    margin-left: 1em;
    > div {
      display: flex;
      align-items: center;
      &:nth-child(2) {
        margin-left: 1em;
        &:before {
          content: "~";
          margin-right: 1em;
        }
      }
    }
  }
  @include sm-view {
    dl {
      display: block;
      margin: 1em 0 .4em;
    }
    dt {
      font-size: 14px;
    }
    dd {
      margin: 0;
    }
  }
}

.downloadBTN {
  &.disabled {
    opacity: .6;
    cursol: default;
    pointer-events: none;
  }
}
.helper_text {
  font-size: .85em;
  color: var(--gray-text, #666);
  margin-bottom: 8px;
}
.required_mark {
  font-size: .75em;
  color: red;
  margin-left: 6px;
}
.last_link_sent {
  font-size: .75em;
  color: var(--gray-text, #666);
  text-align: right;
  margin-top: 8px;
  margin-bottom: 4px;
}
.status_badge_wrap {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  vertical-align: middle;
}
.status_badge {
  display: inline-block;
  font-size: .75em;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
}
// ホバーで詳細を表示する旨を `?` アイコンで明示（PJ 慣行: fa-circle-question + cursor:help）
.status_hint {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: help;
  &:hover .status_tooltip {
    visibility: visible;
    opacity: 1;
  }
}
.status_hint_icon {
  font-size: 13px;
  color: #888;
}
.status_tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 240px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  color: #fff;
  background-color: #333;
  border-radius: 6px;
  white-space: normal;
  transition: opacity 0.2s;
  z-index: 10;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #333;
  }
}
.status_available {
  color: #fff;
  background-color: var(--green-main);
}
.status_pending {
  color: #fff;
  background-color: var(--blue-main);
}
.status_expired {
  color: #fff;
  background-color: var(--orange-main);
}
.status_not_sent {
  color: var(--black);
  background-color: var(--gray-sub);
}
</style>
